import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { JsonPipe, NgClass, SlicePipe, TitleCasePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  AngularEditorConfig,
  AngularEditorModule,
} from '@kolkov/angular-editor';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import {
  Observable,
  Subject,
  catchError,
  forkJoin,
  map,
  switchMap,
  throwError,
} from 'rxjs';
import swal from 'sweetalert2';
import { v4 as uuid } from 'uuid';
import { FormConditionalLogic } from '../../../Models/ConditionalLogic-data.model';
import {
  FormQuestions,
  OptionValues,
  SectionInfo,
  Sections,
} from '../../../Models/Question-details';
import {
  ICheckboxInput,
  IDateInput,
  IDropdownInput,
  IGuidanceInput,
  IMSelectDropdownInput,
  IRadioInput,
  ITextareaInput,
  ITextboxInput,
} from '../../../Models/app.interfaces';
import { ComponentItemList, dataLists } from '../../../Models/form-data.model';
import { ISectionCtrl } from '../../../Models/node.model';
import { BuyerPreviewComponent } from '../../../buyer-preview/buyer-preview.component';
import { BuyerPreviewService } from '../../../buyer-preview/buyer-preview.service';
import { MultiSectionFormPreviewComponent } from '../../../buyer-preview/multi-section-form-preview/multi-section-form-preview.component';
import {
  IField,
  IFormExtractionJSON,
  ISectionInfo,
} from '../../../buyer-preview/multi-section-form-preview/multi-section-form-preview.models';
import { DynamicFieldComponent } from '../../../dynamic-field/dynamic-field.component';
import { ApiServiceService } from '../../../services/api-service.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { NavigationService } from '../../../services/navigation.service';
import { SafeHtmlPipe } from '../../../services/safe-html.pipe';
import { EvalScriptPipe } from '../../../shared/eval-script.pipe';
import { InputBoxValidationPipePipe } from '../../../shared/input-box-validation-pipe.pipe';
import Utils from '../../../shared/utils';
import { FieldCloneService } from './field.clone.service';
import {
  ELEMENTS_LIST,
  MASTER_DATA_FIELDS_LIST,
  WYSWIG_EDITOR_CONFIG,
} from './form-builder.constants';
import { ExcelImportComponent, ImportResult } from '../../excel-import/excel-import.component';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.css'],
  standalone: true,
  imports: [
    NgClass,
    CdkDropList,
    CdkDrag,
    NgbTooltip,
    DynamicFieldComponent,
    FormsModule,
    AngularEditorModule,
    ReactiveFormsModule,
    BuyerPreviewComponent,
    MultiSectionFormPreviewComponent,
    JsonPipe,
    SlicePipe,
    TitleCasePipe,
    SafeHtmlPipe,
    EvalScriptPipe,
    InputBoxValidationPipePipe,
    ExcelImportComponent,
    HeaderComponent,
  ],
})
export class FormBuilderComponent implements OnInit, AfterViewInit {
  isSection = Boolean(this.formLayout?.toLowerCase() === 'multiple');
  defaultAlignment = 'left'; //temporary properties
  defaultJustification = 'horizontal'; //temporary properties

  @ViewChild('modalPreviewContent') modalPreviewContent: any;
  @ViewChild('previewQuestionnaireContent') previewQuestionnaireContent: any;
  @ViewChild('multiSectionQuestionnairePreview')
  multiSectionQuestionnairePreview: any;
  uploadedFile: File[] | null = null;
  @ViewChild('JSONImportContent') JSONImportContent: any;
  importForm = new FormGroup({});
  modalQuestionImportResponse: any;
  @ViewChild('textContent') textContentRef: any;
  @ViewChild('dateentered') dateentered: ElementRef;
  @ViewChild('preview') preview: ElementRef;
  @ViewChild('fileUpload') fileUpload!: ElementRef;

  @ViewChild('sectionFormRef') sectionFormRef!: ElementRef;
  @ViewChild('sectionContent') sectionContentRef!: ElementRef;

  @ViewChild('subSectionFormRef') subSectionFormRef!: ElementRef;
  @ViewChild('subSectionContent') subSectionContentRef!: ElementRef;
  @ViewChild('excelImport') excelImportRef!: ExcelImportComponent;
  @ViewChild('dateForm') dateFormRef: NgForm;
  dateRef: IDateInput = {
    isFutureDateAllowed: false,
    isBetweenSelected: false,
    minPastMonth: null,
    maxFutureMonth: null,
    align: 'left',
  };

  @ViewChild('textareaForm') textareaFormRef: NgForm;
  textareaRef: ITextareaInput = {
    isHidden: false,
    align: 'left',
  };

  @ViewChild('textboxForm') textboxFormRef: NgForm;
  textboxRef: ITextboxInput = {
    formatType: 'text',
    minLength: '',
    maxLength: '',
    align: 'left',
  };

  @ViewChild('dropdownForm') dropdownFormRef: NgForm;
  dropdownRef: IDropdownInput = {
    options: [],
    align: 'left',
    isDefaultValueChecked: false,
    isDisableInputChecked: false,
  };

  @ViewChild('multiSelectDropdownForm') multiSelectDropdownFormRef: NgForm;
  multiSelectDropdownRef: IMSelectDropdownInput = {
    options: [],
    align: 'left',
  };

  @ViewChild('radioForm') radioFormRef: NgForm;
  radioRef: IRadioInput = {
    options: [],
    align: 'left',
  };

  @ViewChild('checkboxForm') checkboxFormRef: NgForm;
  checkboxRef: ICheckboxInput = {
    options: [],
    align: 'left',
  };

  @ViewChild('guidanceForm') guidanceFormRef: NgForm;
  guidanceRef: IGuidanceInput = {
    htmlContent: '',
    align: this.isSection ? 'vertical' : 'horizontal',
  };

  swalWithBootstrapButtons = swal.mixin({
    customClass: {
      confirmButton: 'btn',
      cancelButton: 'btn btn-danger',
    },
    buttonsStyling: false,
  });

  extractedQuestion: string = '';
  extractedConditionalLogic: string = '';

  fileToUpload: any = 'noFile';
  config: AngularEditorConfig = WYSWIG_EDITOR_CONFIG;
  selectedQuestionPreview: any;
  editIndex = -1;
  dragableicon = false;
  isDragablelistDisable = true;
  addToFormShow: boolean = false;
  id: number = 0;
  align: string = '';
  verticallAlign: string = '';
  formData: any = [];
  masterDeletehide = false;
  checkDatas: Array<dataLists> = [];
  checkHeader: any;
  checkID = 0;
  checkItemLists: ComponentItemList[] = [];
  dateitemLists: ComponentItemList[] = [];
  selectalign: string = '';
  dropDownDatas: Array<dataLists> = [];
  DropDownHeader: any;
  dropDownItemLists: ComponentItemList[] = [];
  dropDownID = 0;

  multiselectDropDownDatas: Array<dataLists> = [];
  multiselectDropDownHeader: any;
  multiselectDropDownItemLists: ComponentItemList[] = [];
  multiselectDropDownID = 0;
  placeholderList: any[] = [];

  // textArea submit
  textareaitemLists: ComponentItemList[] = [];
  textboxitemLists: ComponentItemList[] = [];
  textareaDatas = new ComponentItemList();
  textareaHeader: string = '';
  textareaID: number = 0;
  // hide and show
  daterestrict = false;
  isEditModel = false;
  dataEditModel: any;
  previewData: any = [];
  addformData: any = [];
  qcount: number = 0;
  neweditindex1 = -1;
  dategreater: string = '';
  updateShow: boolean = false;
  editcollectionIndex = -1;
  editFormindex: any;
  editQuesQcount: any;
  isShortText = false;
  fileUploadFormData = new FormData();
  originItems_one = ELEMENTS_LIST;
  masterdatafield_lists = MASTER_DATA_FIELDS_LIST;
  maxDate: Date = new Date();
  fieldTypes = [
    'textarea',
    'textbox',
    'dropdown',
    'multiselect-dropdown',
    'date',
    'çheckbox',
    'radio',
  ];

  shortText = new FormControl('', [Validators.maxLength(60)]);
  displayText = new FormControl('');
  mouseOverText = new FormControl('');
  mappableCheck = new FormControl(true);
  fieldType = new FormControl('IndustryData');
  alignment = new FormControl('');
  sectionTitle = new FormControl('');
  sectionDescription = new FormControl('');
  sectionDisplayType = new FormControl('One');
  selectedPlaceholder = new FormControl('');
  accordianCtrl = [
    { id: 1, isOpen: true },
    { id: 2, isOpen: false },
  ];
  IsEdit = 'false';
  FormName = '';
  selectedSectionIndex: number;
  @ViewChild('fm') templateForm: NgForm;
  
  @ViewChild('htmlContent', { read: ElementRef }) htmlContent!: ElementRef;
 /** Absolute caret index (characters from start of editor) */
  private caretIndex: number | null = null;

  /** The actual contenteditable element rendered by angular-editor */
  private get editable(): HTMLElement | null {
    // kolkov/angular-editor renders a contenteditable div with this class
    return this.htmlContent?.nativeElement?.querySelector('.angular-editor-textarea') ?? null;
  }
    
  noop() {
    // This is intentionally left blank to create a no-operation (noop) event.
  }

ngAfterViewInit(): void {
    // Optional: ensure we have an initial caret saved once the editor first gains focus
    this.editable?.addEventListener('focus', () => this.saveCaret());
  }
  onEditorClick(): void { this.saveCaret(); }
  onEditorKeyup(): void { this.saveCaret(); }
  onEditorKeydown(): void { this.saveCaret(); }
private saveCaret(): void {
    const root = this.editable;
    if (!root) return;

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const range = sel.getRangeAt(0);
    if (!range.collapsed) return; // only care about caret, not selections

    const preRange = document.createRange();
    preRange.selectNodeContents(root);
    preRange.setEnd(range.startContainer, range.startOffset);
    this.caretIndex = preRange.toString().length;
  }

  /** Restore caret to a specific absolute index within root */
  private setCaretIndex(root: HTMLElement, index: number): void {
    // Walk through text nodes accumulating lengths until we reach the index
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    let node = walker.nextNode() as Text | null;
    let remaining = index;

    while (node) {
      const len = node.nodeValue?.length ?? 0;
      if (remaining <= len) {
        const range = document.createRange();
        range.setStart(node, Math.max(0, remaining));
        range.collapse(true);

        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
        return;
      }
      remaining -= len;
      node = walker.nextNode() as Text | null;
    }

    // If index is past the end, put caret at end
    const endRange = document.createRange();
    endRange.selectNodeContents(root);
    endRange.collapse(false);
    const sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(endRange);
  }

  // --- Insertion -------------------------------------------------------------

  /** Insert plain text at the last saved caret index */
  private insertAtSavedCaret(text: string): void {
    const root = this.editable;
    if (!root) return;

    // If caret never saved, default to end
    if (this.caretIndex == null) {
      this.caretIndex = root.innerText.length;
    }

    root.focus();
    this.setCaretIndex(root, this.caretIndex);

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return;

    const range = sel.getRangeAt(0);
    range.deleteContents();

    // Insert as a text node (simple, safe)
    const node = document.createTextNode(text);
    range.insertNode(node);

    // Move the caret to just after the inserted text
    range.setStartAfter(node);
    range.collapse(true);

    sel.removeAllRanges();
    sel.addRange(range);

    // Update stored caret (so multiple inserts work)
    this.caretIndex += text.length;

    // Let Angular know the editor content changed
    root.dispatchEvent(new InputEvent('input', { bubbles: true }));
  }
  addPlaceholder() {
    if (!this.selectedPlaceholder.value) return;
    this.insertAtSavedCaret(`{{# ${this.selectedPlaceholder.value} #}}`);
  }

  executeSectionDelete(section, si) {
    this.setSectionDetails(section, si);
    this.deleteSection(section.UniqueID);
  }

  doUnsavedFieldsExist(activeItem: ISectionInfo) {
    const unsavedFields: any[] =
      JSON.parse(localStorage.getItem('ADDFORMDATA')) ?? [];
    const doUnsavedFieldsExistInActiveSectionOrSubSection = unsavedFields?.some(
      (f) => f?.sectionId === activeItem?.UniqueID
    );
    return doUnsavedFieldsExistInActiveSectionOrSubSection;
  }

  get fieldsListMsg(): string | null {
    let msg = null;
    // if selected item is a section
    if (this.activeSection && !this.activeSubSection) {
      // if selected section has sub-sections in it already
      if (this.activeSection?.Sections?.length) {
        msg = 'Please select a sub-section to see its fields';
      }
      // if selected section has fields in it already
      else if (
        this.activeSection?.Fields?.length ||
        this.doUnsavedFieldsExist(this.activeSection)
      ) {
        msg = null;
      } else {
        msg = 'A section can have either only subsections or only fields';
      }
    }
    // if selected item is a sub section of a section
    else if (this.activeSection && this.activeSubSection) {
      // if selected sub-section has fields in it already
      if (
        this.activeSubSection?.Fields?.length ||
        this.doUnsavedFieldsExist(this.activeSubSection)
      ) {
        msg = null;
      } else {
        msg =
          'No fields exist in the selected section. Please drag and drop from elements list to add fields to the section';
      }
    }
    // if selected item is none
    else {
      if (this.sections?.Section?.length) {
        msg = 'Please select a section';
      } else {
        msg = null;
      }
    }
    return msg;
  }

  sectionCtrl: ISectionCtrl[] = [];
  isFormFieldUnsupported = false;

  //Description: if form field is eligible to be added into form - method returns false; else returns true 
  checkFormFieldEligibilty(f: any): boolean {
    let formData = f;
    if (formData) {
      if (formData?.length === 1) {
        const isDraggedElementSubmitter = formData?.every(
          (field: any) => field?.type === 'Submitter'
        );
        // disable the field addition to the form if the fieldType is not Submitter (i.e., if thr drag & drop element is Submitter Element)
        return isDraggedElementSubmitter ? false : true;
      } else if (formData?.length > 1) {
        // if form has more than 1 field
        const isDraggedElementSubmitter = formData?.every(
          (field: any) => field?.type === 'Submitter'
        );
        // disable the field addition to the form - if all the fields are only text and/or Guidance
        const onlyTextorOnlyGuidanceFields = formData?.every(
          (field: any) => field?.type === 'text' || field?.type === 'guidance'
        );
        //disable the field addition to the form - if the first element is not label
        const firstFieldIsNotLabelText = formData?.[0]?.type !== 'text';
        const secondFieldIsNotResponseOption = ['text', 'guidance'].includes(
          formData?.[1]?.type
        );
        const inappropriateFieldOrder =
          firstFieldIsNotLabelText || secondFieldIsNotResponseOption;
        return !isDraggedElementSubmitter && (onlyTextorOnlyGuidanceFields || inappropriateFieldOrder);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  submitterSections = null;

  fieldCloner = inject(FieldCloneService);
  QuesExtractionJSON: any = null;

  constructor(
    private modalService: NgbModal,
    private changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public router: Router,
    public apiService: ApiServiceService,
    public localStorageService: LocalStorageService,
    private _navigationService: NavigationService,
    public buyerPreviewService: BuyerPreviewService
  ) {
    Object.keys(localStorage).forEach((data) => {
      let item = localStorage.getItem(data);
    });
  }
  edidMapdata: any = [];
  SaveCount = 0;
  conditionalLogicData = new FormConditionalLogic();

  previewModeFlag = false;
  mode = '';

  reader = new FileReader();
  onFileChange(event) {
    const file = event.target.files[0];

    this.reader.onload = () => {
      const fileContentUnparsed = this.reader.result?.toString();
      const fileContentParsed = JSON.parse(fileContentUnparsed);

      // Store the file content in local storage

      localStorage.setItem('fileContent', JSON.stringify(fileContentParsed));
    };

    this.reader.readAsText(file);
  }

  doExtractForm() {
    const file: IFormExtractionJSON = JSON.parse(
      localStorage.getItem('fileContent')
    );
    const secDetails = file.getSectionDetails.map((item) => item.Data);

    const secDetailsModified = this.manipulateTemplateIds(secDetails);

    secDetailsModified.forEach((sec) => {
      this.saveCurr(sec);
    });

    const conditionalDetails = {
      ...file.getConditionalDetails,
      TemplateID: localStorage.getItem('TemplateId'),
    };
    this.saveConditionalDetails(conditionalDetails);
  }

  manipulateTemplateIds(sectionData: ISectionInfo[]) {
    sectionData.forEach((sec) => {
      sec.TemplateID = localStorage.getItem('TemplateId');
      if (sec.Sections) this.manipulateTemplateIds(sec.Sections);
    });
    return [...sectionData];
  }

  saveCurr(sec: ISectionInfo) {
    if (!sec.UpdatedBy) {
      sec.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
    }
    this.apiService.SaveSection(sec).subscribe({
      next: () => { },
      error: () => { },
    });
  }

  saveConditionalDetails(conditionalDetails) {
    this.apiService.SaveConditionalLogic(conditionalDetails).subscribe({
      next: () => { },
      error: () => { },
    });
  }

  /**
   * Open the Excel Import dialog
   */
  // Re-import confirmation (mockup slide 13): clicking "Import Form" when a form
  // already exists warns the user before leaving to the Import screen so they can
  // save or discard their current Form Builder work.
  showImportConfirm = false;

  openExcelImport() {
    if (this.sections?.Section?.length) {
      this.showImportConfirm = true;   // existing form → confirm first
      return;
    }
    this.doOpenImport();
  }

  private doOpenImport() {
    if (this.excelImportRef) {
      this.excelImportRef.open();
    }
  }

  /** Cancel → just close the confirmation, stay in the Form Builder. */
  cancelImportConfirm() {
    this.showImportConfirm = false;
  }

  /** Return to Import → go to a fresh Upload screen (the current form remains saved
   *  and can still be edited manually; a new import replaces it if completed). */
  returnToImport() {
    this.showImportConfirm = false;
    if (this.excelImportRef) {
      this.excelImportRef.openFresh();
    }
  }

  /** Live form title for the page heading — from localStorage 'Title' (populated from
   *  Partner.BaseForm when the form config loads). Read live so it shows as soon as ready. */
  get formTitle(): string {
    return localStorage.getItem('Title') || '';
  }

  /**
   * Handle Excel import completion
   */
  /** Summary of the most recent import, shown as the green banner at the top of the
   *  Form Builder ("Imported "file" — N sections, N fields created"). Null until an
   *  import completes in this session. */
  importSummary: { fileName: string; sections: number; fields: number } | null = null;

  onExcelImportComplete(result: ImportResult) {
    // The import wizard shows its own Complete/Success step, so no popup/reload here.
    // We DO capture a summary so the Form Builder can show the green "Imported …" banner.
    if (result?.success) {
      this.importSummary = {
        fileName: result.fileName || '',
        sections: result.sectionsCreated || 0,
        fields: result.fieldsCreated || 0,
      };
    }
  }

  /** After the wizard's goToFormEditor() reloads the page, restore the green "Imported …"
   *  banner from the summary the wizard persisted — but only for the form it belongs to
   *  (match on TemplateId), so opening a different form falls back to "Quick Import". */
  private restoreImportSummary(): void {
    try {
      const raw = localStorage.getItem('AIFB_ImportSummary');
      if (!raw) return;
      const s = JSON.parse(raw);
      const currentTid = localStorage.getItem('TemplateId') || '';
      if (s && (!s.templateId || s.templateId === currentTid)) {
        this.importSummary = {
          fileName: s.fileName || '',
          sections: s.sections || 0,
          fields: s.fields || 0,
        };
      }
    } catch { /* ignore malformed/unavailable storage */ }
  }

  private _formLayout = '';
  public get formLayout() {
    let localStorageFormLayout = localStorage.getItem('FormLayout');
    return (this._formLayout = localStorageFormLayout ?? '');
  }

  ngOnInit(): void {
    this.restoreImportSummary();

    this._navigationService
      .getIsQuestionSaved()
      .subscribe((isQuestionSaved: boolean) => {
        let isQuestionnavigatetoConditionalLogic = true;
        if (isQuestionSaved) {
          this.SaveCount++;
          if (!this.isSection) {
            this.onQuesSave(
              isQuestionnavigatetoConditionalLogic,
              this.SaveCount
            );
          } else {
            this.onNestedQuesSave();
          }
        }
      });
    setTimeout(() => {
      this.placeholderList = this.buyerPreviewService.placeholderList;
    }, 0);

    this.isDragablelistDisable = this.isSection;
    this.FormName = localStorage.getItem('Title') || '';
    this.IsEdit = localStorage.getItem('IsEdit') || 'false';
    if (this.IsEdit == 'True') {
      if (this.isSection) {
        this.prepareMultiSectionFormdesigner();
        this.isSaved = true;
      } else {
        let sectionid = localStorage.getItem('SectionId') || '';
        this.editFormdesigner(sectionid);
      }
    } else {
      let sectionid = localStorage.getItem('SectionId') || '';
      this.editFormdesigner(sectionid);
    }
    if (!this.isSection) {
      let sectionInfo = new SectionInfo();
      this.currentSectionID = localStorage.getItem('SectionId') || '';
      sectionInfo.UniqueID = localStorage.getItem('SectionId') || '';
      sectionInfo.Title = localStorage.getItem('Title') || '';
      sectionInfo.Description = localStorage.getItem('Title') || '';
      sectionInfo.TemplateID = localStorage.getItem('TemplateId') || '';

      sectionInfo.CreatedBy.UniqueID = localStorage.getItem('UserId');
      sectionInfo.UpdatedBy.UniqueID = localStorage.getItem('UserId');
      this.sections.Section.push(sectionInfo);
      this.activeSection = this.sections.Section.find(
        (s) => s.UniqueID === this.currentSectionID
      );
      this.activeSubSection = this.activeSection.Sections.find(
        (ss) => ss.UniqueID === this.currentSubSectionID
      );
    }

    //Get Conditional Logic details after the GetSections and GetSectionDetails APIs give some response
    this.helper.subscribe((helperVal: string) => {
      if (helperVal === 'submitter sections updated') {
        this.triggerGetConditionaDetails();
      }
    });

    this.previewModeFlag =
      localStorage.getItem('PreviewMode')?.toLowerCase() === 'true';

    this.mode = localStorage.getItem('mode') ?? '';
  }

  triggerGetConditionaDetails() {
    this.apiService.GetConditionaDetails().subscribe({
      next: (response: any) => {
        // Omit all the submitter sections from the Get Conditional response before locally storing
        response.Data.SectionConditions =
          response.Data?.SectionConditions?.filter(
            (section) =>
              !this.submitterSections
                ?.map((submitter) => submitter.UniqueID)
                ?.includes(section.SectionUniqueID)
          );

        this.conditionalLogicData = response.Data;
        localStorage.setItem(
          'ConditionalLogicData',
          JSON.stringify(response.Data)
        );
      },
      error: () => {
        if (window.location.origin.includes('localhost')) {
          const sections = JSON.parse(localStorage.getItem('AllQuestions'))[0]
            .Section;
          const conditionalLogicData = {
            TemplateID: localStorage.getItem('TemplateId') ?? '',
            ChartJson: null,
            SectionConditions: sections.map((secItem) => ({
              UniqueID: secItem.UniqueID,
              ConditionalLogic: [],
            })),
          };
          this.conditionalLogicData = conditionalLogicData;
          localStorage.setItem(
            'ConditionalLogicData',
            JSON.stringify(this.conditionalLogicData)
          );
        }
      },
    });
  }

  resetAllModalRefs() {
    this.dateRef = {
      isFutureDateAllowed: false,
      isBetweenSelected: false,
      minPastMonth: null,
      maxFutureMonth: null,
      align: 'left',
    };
    this.textareaRef = {
      isHidden: false,
      align: 'left',
    };
    this.textboxRef = {
      formatType: 'text',
      minLength: '',
      maxLength: '',
      align: 'left',
    };
    this.dropdownRef = {
      options: [],
      align: 'left',
      isDefaultValueChecked: false,
      isDisableInputChecked: false,
    };
    this.multiSelectDropdownRef = {
      options: [],
      align: 'left',
    };
    this.radioRef = {
      options: [],
      align: 'left',
    };
    this.checkboxRef = {
      options: [],
      align: 'left',
    };
    this.guidanceRef = {
      htmlContent: '',
      align: this.isSection ? 'vertical' : 'horizontal',
    };
  }

  getQuestionID() {

    if (this.EditingQuetionID) {
      this.QuestionID = this.EditingQuetionID;
    } else {
      if (this.QuestionID) {
        this.QuestionID = this.QuestionID;
      } else {
        this.QuestionID = uuid();
      }
    }
  }

  drop(
    event: CdkDragDrop<string[]>,
    textContent: any,
    radioContent: any,
    checkContent: any,
    dateContent: any,
    dropdownContent: any,
    multiselectDropdownContent: any,
    textareaContent: any,
    textboxContent: any,
    guidanceContent: any,
    masterdatatextContent: any,
    fileContent: any,
    submitterContent: any
  ) {
    this.placeholderList = this.buyerPreviewService.placeholderList;
    const swalWithBootstrapButtons = swal.mixin({
      customClass: {
        confirmButton: 'btn',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });
    if (!this.isSubmitterSaved && event.item.data.type != 'Submitter') {
      swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save Submitter Control',
        icon: 'warning',
      });
      this.currentSectionID = this.submitterSectionID;
      return;
    }
    if (event.item.data.type != 'Submitter') {
      this.currentSectionID = localStorage.getItem('SectionId');
      this.isSubmitterdisabled = true;
    } else {
      this.currentSectionID = this.submitterSectionID;
    }
    this.EditingQuetionID = '';
    this.isShortText ? (this.isShortText = false) : this.isShortText;
    this.config.editable = true;
    this.shortText.setValue('');
    this.displayText.setValue('');
    this.mouseOverText.setValue('');
    this.mappableCheck.setValue(true);
    this.fieldType.setValue('IndustryData');
    let fieldFound =
      event.item.data.type == 'text' || event.item.data.type == 'guidance'
        ? false
        : this.formData.some(
          (field: any) => field.type === event.item.data.type
        );
    let isFieldExistedInForm = false;
    if (event.item.data.type != 'text' && event.item.data.type != 'guidance') {

      isFieldExistedInForm = this.formData.some((formQues: any) =>
        this.fieldTypes.includes(formQues.type)
      );
    } else {
      isFieldExistedInForm = false;
    }

    if (
      (!fieldFound && !isFieldExistedInForm) ||
      event.item.data.type == 'Submitter'
    ) {
      this.editIndex = -1;
      this.guidanceRef.htmlContent = ``;
      this.masterDeletehide = false;
      if (event.previousContainer === event.container) {
        moveItemInArray(
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      } else if (event.item.data.type == 'text') {
        this.config.toolbarHiddenButtons[1].push('insertImage');
        if (event.item.data.subType == 'shortText') {
          this.isShortText = true;
        }
        this.modalService.open(textContent, {
          size: 'xl',
          scrollable: false,
          windowClass: 'modalHeight',
        });
      } else if (event.item.data.type == 'radio') {
        this.radioRef.options = [
          { id: 1, optionid: uuid(), answer: '', selected: false },
        ];
        this.modalService.open(radioContent, { size: 'lg', scrollable: true });
      } else if (event.item.data.type == 'checkbox') {
        this.checkboxRef.options = [
          { id: 1, optionid: uuid(), answer: '', selected: false },
        ];
        this.modalService.open(checkContent, { size: 'lg', scrollable: true });
      } else if (event.item.data.type == 'date') {
        this.modalService.open(dateContent, { size: 'lg', scrollable: true });
      } else if (event.item.data.type == 'dropdown') {
        this.dropdownRef.options = [
          { id: 1, optionid: uuid(), answer: '', selected: false },
        ];
        this.modalService.open(dropdownContent, {
          size: 'lg',
          scrollable: true,
        });
      } else if (event.item.data.type == 'multiselect-dropdown') {
        this.multiSelectDropdownRef.options = [
          { id: 1, optionid: uuid(), answer: '', selected: false },
        ];
        this.modalService.open(multiselectDropdownContent, {
          size: 'lg',
          scrollable: true,
        });
      } else if (event.item.data.type == 'textarea') {
        this.modalService.open(textareaContent, {
          size: 'lg',
          scrollable: true,
        });
      } else if (event.item.data.type == 'file') {
        this.clearFile();
        this.modalService.open(fileContent, {
          size: 'lg',
          scrollable: true,
        });
      } else if (event.item.data.type == 'textbox') {
        this.modalService.open(textboxContent, {
          size: 'lg',
          scrollable: true,
        });
      } else if (event.item.data.type == 'guidance') {
        if (this.config.toolbarHiddenButtons[1].includes('insertImage')) {
          this.config.toolbarHiddenButtons[1].pop();
        }

        this.editIndex = -1;
        this.guidanceRef.htmlContent = ``;
        this.modalService.open(guidanceContent, {
          size: 'xl',
          scrollable: true,
        });
      } else if (event.item.data.type == 'Submitter') {
        this.isDragablelistDisable = true;
        if (this.formData.length >= 10) {
          const swalWithBootstrapButtons = swal.mixin({
            customClass: {
              confirmButton: 'btn',
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          });

          swalWithBootstrapButtons.fire({
            title: 'Warning!',
            text: 'Only 10 submitter controles are allowed',
            icon: 'warning',
          });
        } else {
          this.modalService.open(submitterContent, {
            size: 'xl',
            scrollable: false,
            windowClass: 'modalHeight',
          });
        }
      } else {
        var masterDataText = event.item.data.fieldname;
        var masterDataID = event.item.data.FieldID;
        if (
          !this.formData
            .map((x: { FieldID: any }) => x.FieldID)
            .includes(event.item.data.FieldID)
        ) {
          this.masterdatacontent(masterDataText, masterDataID);
        } else {
          alert('Duplicate not allowed');
        }
      }

      if (!this.updateShow) {
        this.editFormindex = -1;
        this.addToFormShow = true;
        this.updateShow = false;
      }
    } else {
      alert('Only one respone option is allowed per question');
    }
  }

  getImgPathByType(type: any) {
    let pathFound = this.originItems_one.find((item) => item.type == type);
    return pathFound ? pathFound.img : 'assets/img/brand.png';
  }

  // submit label
  QuestionID = '';
  onSubmitText(f: NgForm, editIndex: any) {
    this.getQuestionID();

    var textDiv = document.createElement('div');
    var textuniqueId = this.QuestionID;
    textDiv.id = 'label_' + textuniqueId;
    textDiv.setAttribute('maxLength', '40');
    let element;
    if (this.isShortText) {
      element = document
        .createRange()
        .createContextualFragment(this.shortText.value || '');
    } else {
      element = document
        .createRange()
        .createContextualFragment(this.guidanceRef.htmlContent);
    }

    textDiv.appendChild(element);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: textDiv.outerHTML,
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'text',
        value: this.isShortText ? this.shortText.value : textDiv.outerText,
        QuestionId: this.QuestionID,
        isShortText: this.isShortText,
        dispalyFCText: this.displayText.value,
        mouseOverText: this.mouseOverText.value,
        mappableCheck: this.mappableCheck.value,
        fieldType: this.fieldType.value,
        alignment: f.value.align,
      });
    } else {
      this.formData.push({
        divcontnt: textDiv.outerHTML,
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'text',
        value: this.isShortText ? this.shortText.value : textDiv.outerText,
        QuestionId: this.QuestionID,
        isShortText: this.isShortText,
        dispalyFCText: this.displayText.value,
        mouseOverText: this.mouseOverText.value,
        mappableCheck: this.mappableCheck.value,
        fieldType: this.fieldType.value,
        alignment: f.value.align,
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Text submit successful");
  }

  onSubmitSubmitter(f: NgForm, editIndex: any) {
    if (this.EditingQuetionID) {
      this.QuestionID = this.EditingQuetionID;
    } else {
      this.QuestionID = uuid();
    }

    var textDiv = document.createElement('div');
    var textuniqueId = this.QuestionID;
    textDiv.id = 'label_' + textuniqueId;
    textDiv.setAttribute('maxLength', '40');
    let element;
    if (this.isShortText) {
      element = document
        .createRange()
        .createContextualFragment(this.shortText.value || '');
    } else {
      element = document
        .createRange()
        .createContextualFragment(this.guidanceRef.htmlContent);
    }

    textDiv.appendChild(element);
    let textboxhtmlcontent = ``;
    if (f.value.inputType == '') {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:` +
        f.value.align +
        `'><input type="text" id="textboxID_` +
        this.QuestionID +
        `"></input></div><br>`;
    } else {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:` +
        f.value.align +
        `'><input type='` +
        f.value.inputType +
        `' id="textboxID_` +
        this.QuestionID +
        `"></input></div><br>`;
    }

    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: textDiv.outerHTML,
        textdivcontnt:
          this.sanitizer.bypassSecurityTrustHtml(textboxhtmlcontent),
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'Submitter',
        value: this.isShortText ? this.shortText.value : textDiv.outerText,
        QuestionId: this.QuestionID,
        isShortText: this.isShortText,
        dispalyFCText: this.displayText.value,
        mouseOverText: this.mouseOverText.value,
        alignment: f.value.align,
        inputType: f.value.inputType ? f.value.inputType : 'text',
        minLength: f.value.minLength,
        maxLength: f.value.maxLength,
      });
    } else {
      this.formData.push({
        divcontnt: textDiv.outerHTML,
        textdivcontnt:
          this.sanitizer.bypassSecurityTrustHtml(textboxhtmlcontent),
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'Submitter',
        value: this.isShortText ? this.shortText.value : textDiv.outerText,
        QuestionId: this.QuestionID,
        isShortText: this.isShortText,
        dispalyFCText: this.displayText.value,
        mouseOverText: this.mouseOverText.value,
        alignment: f.value.align,
        inputType: f.value.inputType ? f.value.inputType : 'text',
        minLength: f.value.minLength,
        maxLength: f.value.maxLength,
      });
    }
    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Submitter submit successful");
  }

  // submit label
  onSubmitShortText(f: NgForm, editIndex: any) {
    var textDiv = document.createElement('div');
    var textuniqueId = this.create_UUID();
    textDiv.id = textuniqueId;
    textDiv.setAttribute('maxLength', '40');
    let element = document
      .createRange()
      .createContextualFragment(this.guidanceRef.htmlContent);
    textDiv.appendChild(element);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: textDiv.outerHTML,
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'text',
        value: textDiv.outerText,
        isShortText: this.isShortText,
        alignment: f.value.align,
      });
    } else {
      this.formData.push({
        divcontnt: textDiv.outerHTML,
        displaytext: 'Label',
        index: this.formData.length + 1,
        type: 'text',
        value: textDiv.outerText,
        isShortText: this.isShortText,
        alignment: f.value.align,
      });
    }

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Short text / label submit successful");
  }

  // submit Radio
  onSubmitRadio(f: NgForm, editIndex: any) {
    this.getQuestionID();

    this.id = 0;
    let radiohtmlcontent: any = ``;
    var radioDiv = document.createElement('div');
    var radioName = 'Radio_' + this.QuestionID;
    for (var i = 0; i < this.radioRef.options.length; i++) {
      var text = this.radioRef.options[i].answer;
      let radiouniqueValue = this.radioRef.options[i].optionid || '';

      const radioinnerDiv = document.createElement('div');

      var radioBut = document.createElement('input');
      radioBut.value = radiouniqueValue;
      radioBut.setAttribute('style', 'margin-right:5px; vertical-align: middle;');
      radioBut.setAttribute('type', 'radio');
      radioBut.setAttribute('name', radioName);
      radioDiv.appendChild(radioBut);

      var label = document.createElement('label');
      label.appendChild(radioBut);
      label.setAttribute('style', 'padding:0px 10px; display: inline-flex; align-items: center;');
      label.appendChild(document.createTextNode(text));
      radioinnerDiv.appendChild(label);
      radioDiv.appendChild(radioinnerDiv);
    }

    if (f.value.align == 'left') {
      radioDiv.setAttribute('style', 'text-align:left');
    } else if (f.value.align == 'center') {
      radioDiv.setAttribute('style', 'text-align:center');
    } else if (f.value.align == 'right') {
      radioDiv.setAttribute('style', 'text-align:right');
    }

    this.sanitizer.bypassSecurityTrustHtml(radiohtmlcontent);

    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(radioDiv.outerHTML),
        displaytext: 'radioButton',
        radiodata: this.radioRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'radio',
        alignment: f.value.align,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(radioDiv.outerHTML),
        displaytext: 'radioButton',
        radiodata: this.radioRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'radio',
        alignment: f.value.align,
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Radio submit successful");
  }

  addRadioList() {
    this.id++;

    this.radioRef.options.push({
      id: this.id + 1,
      optionid: uuid(),
      selected: false,
      answer: '',
    });
  }

  removeRadioList(i: any, id: any) {
    this.radioRef.options.splice(i, 1);
  }

  // guidance text submit
  onSubmitGuidance(f: NgForm, editIndex: any) {
    if (this.isSection) {
      // multi section form layout
      this.multiSectionFormGuidanceSubmit(f, editIndex);
    } else {
      // single section form layout
      this.singleSectionFormGuidanceSubmit(f, editIndex);
    }
  }

  singleSectionFormGuidanceSubmit(f: NgForm, editIndex: any) {
    this.getQuestionID();

    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.guidanceRef.htmlContent,
        displaytext: this.guidanceRef.htmlContent.replace(/<[^>]+>/g, ''),
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'guidance',
        alignment: this.isSection ? 'vertical' : 'horizontal',
      });
    } else {
      this.formData.push({
        divcontnt: this.guidanceRef.htmlContent,
        displaytext: this.guidanceRef.htmlContent.replace(/<[^>]+>/g, ''),
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'guidance',
        alignment: this.isSection ? 'vertical' : 'horizontal',
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("single section Guidance submit successful");
  }

  multiSectionFormGuidanceSubmit(f: NgForm, editIndex: any) {
    this.getQuestionID();

    const getDisplayText = this.guidanceRef.htmlContent
      ? `[${this.isSection ? 'vertical' : 'horizontal'
      }]:::${this.guidanceRef.htmlContent.replace(/<[^>]+>/g, '')}`
      : '';

    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.guidanceRef.htmlContent,
        displaytext: getDisplayText,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'guidance',
        alignment: this.isSection ? 'vertical' : 'horizontal',
      });
    } else {
      this.formData.push({
        divcontnt: this.guidanceRef.htmlContent,
        displaytext: getDisplayText,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'guidance',
        alignment: this.isSection ? 'vertical' : 'horizontal',
      });
    }

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("multi section Guidance submit successful");
  }

  // edit question component
  EditingQuetionID = '';

  editComponent(editData: any, popupContent: any, i: any) {
    this.placeholderList = this.buyerPreviewService.placeholderList;
    this.EditingQuetionID = '';
    this.EditingQuetionID = editData.QuestionId;
    this.guidanceRef.htmlContent = ``;
    if (editData.type == 'text') {
      this.displayText.setValue(editData.dispalyFCText);
      this.mouseOverText.setValue(editData.mouseOverText);
      this.mappableCheck.setValue(editData.mappableCheck);
      this.fieldType.setValue(editData.fieldType);
      this.guidanceRef.htmlContent = editData.divcontnt;
    } else if (editData.type == 'textbox') {
      this.textboxRef.align = editData.alignment ?? 'left';
      this.textboxRef.formatType = editData.inputType ?? 'unknown';
      if (editData.minLength) {
        this.textboxRef.minLength = editData.minLength;
      }
      if (editData.maxLength) {
        this.textboxRef.maxLength = editData.maxLength;
      }
    } else if (editData.type == 'radio') {
      this.radioRef.options = editData.radiodata;
      this.radioRef.align = editData.alignment ?? 'left';
    } else if (editData.type == 'guidance') {
      this.guidanceRef.htmlContent = editData.divcontnt;
      this.guidanceRef.align = editData.alignment ?? 'left';
    } else if (editData.type == 'checkbox') {
      this.checkboxRef.options = editData.checkboxdata;
      this.checkboxRef.align = editData.alignment ?? 'left';
    } else if (editData.type == 'dropdown') {
      this.dropdownRef.options = editData.dropdowndata;
      this.dropdownRef.align = editData.alignment ?? 'left';
      this.dropdownRef.isDisableInputChecked =
        editData.isDisableInputChecked ?? false;
      this.dropdownRef.isDefaultValueChecked =
        editData.isDefaultValueChecked ?? false;
    } else if (editData.type == 'multiselect-dropdown') {
      this.multiSelectDropdownRef.options = editData.multiselectDropdowndata;
      this.multiSelectDropdownRef.align = editData.alignment ?? 'left';
    } else if (editData.type == 'Submitter') {
      this.displayText.setValue(editData.dispalyFCText);
      this.mouseOverText.setValue(editData.mouseOverText);
      if (editData.divcontnt['changingThisBreaksApplicationSecurity']) {
        let content: SafeHtml;
        content = this.sanitizer.bypassSecurityTrustHtml(
          editData.divcontnt.changingThisBreaksApplicationSecurity
        );
        this.guidanceRef.htmlContent = content;
      } else {
        this.guidanceRef.htmlContent = editData.divcontnt;
      }
    } else if (editData.type == 'textarea') {
      this.textareaRef.isHidden = editData.isHidden ?? false;
      this.textareaRef.align = editData.alignment ?? 'left';
    } else if (editData.type == 'date') {
      this.dateRef.isBetweenSelected = editData.isBetweenSelected ?? false;
      this.dateRef.isFutureDateAllowed = editData.isFutureDateAllowed ?? false;
      this.dateRef.minPastMonth = editData.minPastMonth;
      this.dateRef.maxFutureMonth = editData.maxFutureMonth;
      this.dateRef.align = editData.alignment ?? 'left';
    }
    this.editIndex = i;
    this.guidanceRef.htmlContent = editData.divcontnt;
    if (editData.isShortText) {
      this.isShortText = true;
      this.modalService.open(this.textContentRef, {
        size: 'lg',
        scrollable: true,
      });
    } else {
      this.modalService.open(popupContent, { size: 'lg', scrollable: true });
    }
  }
  // delete question component
  deleteComponent(i: any) {
    this.formData.splice(i, 1);
    if (!this.formData.length) {
      this.isSubmitterdisabled = false;
    }
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);
  }

  // checkbox submit

  onSubmitCheck(f: NgForm, editIndex: any) {
    this.getQuestionID();

    this.id = 0;
    let checkboxhtmlcontent = ``;

    const checkboxDiv = document.createElement('div');
    checkboxDiv.id = `Checkbox_WRAPPER_${this.QuestionID}`;
    for (var i = 0; i < this.checkboxRef.options.length; i++) {
      var text = this.checkboxRef.options[i].answer;

      var checkboxinnerDiv = document.createElement('div');
      checkboxinnerDiv.id = `Checkbox_Container${i}_${this.QuestionID}`;

      var checkboxBut = document.createElement('input');
      checkboxBut.setAttribute('type', 'checkbox');
      var checkuniqueId = 'Checkbox_' + this.checkboxRef.options[i].optionid;
      checkboxBut.setAttribute('style', 'margin-right:5px; vertical-align: middle;');
      checkboxBut.id = checkuniqueId;

      var label = document.createElement('label');
      label.id = `Checkbox_Label${i}_${this.QuestionID}`;
      label.appendChild(checkboxBut);
      label.setAttribute('style', 'padding:0px 10px; display: inline-flex; align-items: center;');
      label.appendChild(document.createTextNode(text));

      checkboxinnerDiv.appendChild(label);
      checkboxDiv.appendChild(checkboxinnerDiv);
    }


    if (f.value.align == 'left') {
      checkboxDiv.setAttribute('style', 'text-align:left');
    } else if (f.value.align == 'center') {
      checkboxDiv.setAttribute('style', 'text-align:center');
    } else if (f.value.align == 'right') {
      checkboxDiv.setAttribute('style', 'text-align:right');
    }

    this.sanitizer.bypassSecurityTrustHtml(checkboxhtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(
          checkboxDiv.outerHTML
        ),
        displaytext: 'checkboxButton',
        checkboxdata: this.checkboxRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'checkbox',
        alignment: f.value.align,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(
          checkboxDiv.outerHTML
        ),
        displaytext: 'checkboxButton',
        checkboxdata: this.checkboxRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'checkbox',
        alignment: f.value.align,
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    this.modalService.dismissAll();
    this.resetAllModalRefs();
  }

  removeCheckList(i: any, id: any) {
    this.checkboxRef.options.splice(i, 1);

    if (this.isEditModel) {
      this.dataEditModel.dataItems.splice(i, 1);
    }
  }

  addCheckList() {
    this.id++;
    this.checkboxRef.options.push({
      id: this.id + 1,
      optionid: uuid(),
      selected: false,
      answer: '',
    });
  }

  onSubmitDate(fm: NgForm, editIndex: any) {

    this.getQuestionID();

    const hash = this.QuestionID.replaceAll('-', '_');
  let datehtmlcontent = `<div style="text-align:${fm.value.align}">
      <input
        type="date"
        id="${this.QuestionID}"
        onfocus="this.showPicker && this.showPicker()"
        onkeydown="this.showPicker && this.showPicker(); return false;"
        onpaste="return false"
        style="background-color: white; cursor: pointer;"
      />
    </div>

    <script>
      function deltaDate(input, days = 0, months = 0, years = 0) {
        const y = input.getFullYear() + years;
        const m = input.getMonth() + months;
        const d = new Date(y, m, 1);
        const maxDay = new Date(y, m + 1, 0).getDate();
        d.setDate(Math.min(input.getDate(), maxDay));
        d.setDate(d.getDate() + days);
        d.setHours(0,0,0,0);
        return d;
      }

      function toInputDateLocal(dt) {
        const local = new Date(dt.getTime() - dt.getTimezoneOffset() * 60000);
        return local.toISOString().split('T')[0];
      }

      (function () {
        const dateEl_${hash} = document.getElementById('${this.QuestionID}');
        if (!dateEl_${hash}) return;

        const today_${hash} = new Date();
        today_${hash}.setHours(0,0,0,0);

        const isFutureAllowed_${hash} = ${fm.value.isFutureDateAllowed ? 'true' : 'false'};
        const maxFutureMonth_${hash}  = ${fm.value.isFutureDateAllowed ? (fm.value.maxFutureMonth ?? 12) : 0};
        const minPastMonth_${hash}    = ${fm.value.minPastMonth ?? 12};

        const minDate_${hash} = deltaDate(today_${hash}, 0, -Number(minPastMonth_${hash}), 0);
        const maxDate_${hash} = isFutureAllowed_${hash}
          ? deltaDate(today_${hash}, 0, +Number(maxFutureMonth_${hash}), 0)
          : new Date(today_${hash}); // today if future not allowed
        dateEl_${hash}.setAttribute('min', toInputDateLocal(minDate_${hash}));
        dateEl_${hash}.setAttribute('max', toInputDateLocal(maxDate_${hash}));
      })();
      const dateHtmlInputElement_${hash} = document.getElementById('${
      this.QuestionID
    }');
      console.log('dateHtmlInputElement_${hash}:', dateHtmlInputElement_${hash})
      let currDate_${hash} = new Date();
      const maxFutureMonth_${hash} = ${
      fm.value.isFutureDateAllowed ? fm.value.maxFutureMonth ?? 12 : 0
    };
      const minPastMonth_${hash} = ${fm.value.minPastMonth ?? 12};
      console.log('min-curr-max', minPastMonth_${hash}, currDate_${hash}, maxFutureMonth_${hash})
      const maxDate_${hash} = deltaDate(currDate_${hash}, 0, +maxFutureMonth_${hash}, 0).toISOString().split("T")[0]
      const minDate_${hash} = deltaDate(currDate_${hash}, 0, -minPastMonth_${hash}, 0).toISOString().split("T")[0]
      console.log("From The Script::", minDate_${hash}, maxDate_${hash})
      if(dateHtmlInputElement_${hash} && minDate_${hash} && maxDate_${hash}) {
        dateHtmlInputElement_${hash}.setAttribute('min', minDate_${hash})
        dateHtmlInputElement_${hash}.setAttribute('max', maxDate_${hash})
      }
    </script>
    `;

    this.sanitizer.bypassSecurityTrustHtml(datehtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(datehtmlcontent),
        displaytext: 'dateButton',
        datedata: this.dateitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'date',
        value: '',
        alignment: fm.value.align,
        isFutureDateAllowed: fm.value.isFutureDateAllowed,
        isBetweenSelected: fm.value.isBetweenSelected,
        minPastMonth: fm.value.minPastMonth,
        maxFutureMonth: fm.value.maxFutureMonth,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(datehtmlcontent),
        displaytext: 'dateButton',
        datedata: this.dateitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'date',
        value: '',
        alignment: fm.value.align,
        isFutureDateAllowed: fm.value.isFutureDateAllowed,
        isBetweenSelected: fm.value.isBetweenSelected,
        minPastMonth: fm.value.minPastMonth,
        maxFutureMonth: fm.value.maxFutureMonth,
      });
    }

    let radioValue = [fm.value];
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Date submit successful");
  }
  // dropdown Submit
  onSubmitDropdwon(fm: NgForm, editIndex: any) {
    this.getQuestionID();

    this.id = 0;
    this.selectalign = fm.value.align;
    let dropdownhtmlcontent = ``;

    //Create and append select list
    var selectDiv = document.createElement('div');
    var selectList = document.createElement('select');

    var selectuniqueId = 'Dropdown_' + this.QuestionID;
    selectList.id = selectuniqueId;
    selectDiv.appendChild(selectList);

    selectList.setAttribute(
      'style',
      'padding: 5px 10px;width: 200px;outline:none;border-radius: 5px;'
    );

    if (
      !this.dropdownRef.isDisableInputChecked ||
      !this.dropdownRef.isDefaultValueChecked
    ) {
      selectList.insertAdjacentHTML(
        'afterbegin',
        `<option value="">Select option</option>`
      );
    }

    for (let i = 0; i < this.dropdownRef.options.length; i++) {
      if (this.dropdownRef.options[i].answer !== 'Select option') {
        let option = document.createElement('option');
        let selectuniqueValue = this.dropdownRef.options[i].optionid ?? '';
        option.setAttribute('value', selectuniqueValue);
        if (
          this.dropdownRef.isDefaultValueChecked ||
          (this.dropdownRef.isDisableInputChecked && i == 0)
        ) {
          option.selected = true;
          option.setAttribute('selected', 'true');
        }
        option.text = this.dropdownRef.options[i].answer;
        selectList.appendChild(option);
      }
    }

    if (fm.value.align == 'left') {
      selectDiv.setAttribute('style', 'display:flex;justify-content:left;');
    } else if (fm.value.align == 'center') {
      selectDiv.setAttribute('style', 'display:flex;justify-content:center;');
    } else if (fm.value.align == 'right') {
      selectDiv.setAttribute('style', 'display:flex;justify-content:right;');
    }

    if (this.dropdownRef.isDisableInputChecked) {
      selectList.setAttribute('disabled', 'true');
    }

    this.sanitizer.bypassSecurityTrustHtml(dropdownhtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(selectDiv.outerHTML),
        displaytext: 'dropdownButton',
        dropdowndata: this.dropdownRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'dropdown',
        alignment: fm.value.align,

        isDisableInputChecked: fm.value.isDisableInputChecked,
        isDefaultValueChecked: fm.value.isDefaultValueChecked,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(selectDiv.outerHTML),
        displaytext: 'dropdownButton',
        dropdowndata: this.dropdownRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'dropdown',
        alignment: fm.value.align,
        isDisableInputChecked: fm.value.isDisableInputChecked,
        isDefaultValueChecked: fm.value.isDefaultValueChecked,
      });
    }
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Dropdown  submit successful");
  }

  // Multiselect dropdown
  onSubmitMultiselectDropdwon(fm: NgForm, editIndex: any) {
    this.getQuestionID();

    this.id = 0;
    this.selectalign = fm.value.align;
    let multiselectDropdownhtmlcontent = ``;

    //Create and append select list
    var selectDiv = document.createElement('div');
    var selectList = document.createElement('select');
    selectList.classList.add('form-select');

    //userMsg
    const userMsgDiv = document.createElement('div');
    userMsgDiv.setAttribute(
      'style',
      `margin-top: 0.5rem; margin-bottom: 0.5rem;`
    );
    const userMsg = document.createElement('small');
    userMsg.setAttribute('style', `font-size: 0.7rem; font-weight: 400;`);
    userMsg.innerHTML = `Hold down the <b>Ctrl</b> (windows) or <b>Command</b> (Mac) button to select multiple options.`;
    userMsgDiv.insertAdjacentElement('afterbegin', userMsg);

    // Set multi attribute
    selectList.setAttribute('multiple', 'true');
    selectDiv.insertAdjacentElement('beforeend', userMsgDiv);

    var selectuniqueId = 'MultiselectDropdown_' + this.QuestionID;
    selectList.id = selectuniqueId;
    selectDiv.insertAdjacentElement('afterbegin', selectList);

    let allOptionStrings = [];
    for (let i = 0; i < this.multiSelectDropdownRef.options.length; i++) {
      var option = document.createElement('option');
      let selectuniqueValue =
        this.multiSelectDropdownRef.options[i].optionid || '';
      option.setAttribute('value', selectuniqueValue);
      option.text = this.multiSelectDropdownRef.options[i].answer;

      selectList.appendChild(option);
      allOptionStrings.push(option.text);
    }

    const lengthiestOption = allOptionStrings?.sort(
      (o1, o2) => o2?.length - o1?.length
    )[0];

    selectList.setAttribute(
      'style',
      `padding: 5px 10px; width: ${lengthiestOption?.length}em; max-width: 55%; overflow-x: auto; outline:none; border-radius: 5px; height: 100px;`
    );

    if (fm.value.align == 'left') {
      selectDiv.setAttribute(
        'style',
        'display:flex; flex-direction:column; align-items:start;'
      );
    } else if (fm.value.align == 'center') {
      selectDiv.setAttribute(
        'style',
        'display:flex; flex-direction:column; align-items:center;'
      );
    } else if (fm.value.align == 'right') {
      selectDiv.setAttribute(
        'style',
        'display:flex; flex-direction:column; align-items:end;'
      );
    }

    this.sanitizer.bypassSecurityTrustHtml(multiselectDropdownhtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(selectDiv.outerHTML),
        displaytext: 'multiselectDropdownButton',
        multiselectDropdowndata: this.multiSelectDropdownRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'multiselect-dropdown',
        alignment: fm.value.align,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(selectDiv.outerHTML),
        displaytext: 'multiselectDropdownButton',
        multiselectDropdowndata: this.multiSelectDropdownRef.options,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'multiselect-dropdown',
        alignment: fm.value.align,
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Multi select dropdown submit successful");
  }

  // remove dropdown content from popup
  removeDropDownList(i: any, id: any) {
    this.dropdownRef.options.splice(i, 1);
  }
  removeCheckboxList(i: any, id: any) {
    this.checkboxRef.options.splice(i, 1);
  }

  // remove multiselect dropdown content from popup
  removeMultiselectDropDownList(i: any, id: any) {
    this.multiSelectDropdownRef.options.splice(i, 1);
  }

  addDropDownList() {
    this.id++;

    this.dropdownRef.options.push({
      id: this.id + 1,
      optionid: uuid(),
      selected: false,
      answer: '',
    });
  }

  // add multiselect
  addMultiselectDropDownList() {
    this.id++;
    this.multiSelectDropdownRef.options.push({
      id: this.id + 1,
      optionid: uuid(),
      selected: false,
      answer: '',
    });
  }

  onSubmitTextArea(fm: NgForm, editIndex: any) {
    this.getQuestionID();

    let textareahtmlcontent = ``;
    let DataExpression = 0;
    textareahtmlcontent =
      textareahtmlcontent +
      `
      <div style='text-align:${fm.value.align}'>
        <textarea type="text" id="textareaID_${this.QuestionID
      }" style="display:${fm.value.isHidden ? 'none' : 'block'}"></textarea>
      </div><br/>
      `;
    this.sanitizer.bypassSecurityTrustHtml(textareahtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(textareahtmlcontent),
        displaytext: 'textArea',
        textareadata: this.textareaitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'textarea',
        alignment: fm.value.align,
        isHidden: fm.value.isHidden,
        dataExpression: DataExpression,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(textareahtmlcontent),
        displaytext: 'textArea',
        textareadata: this.textareaitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'textarea',
        alignment: fm.value.align,
        isHidden: fm.value.isHidden,
        dataExpression: DataExpression,
      });
    }

    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Text area submit successful");
  }

  onSubmitTextbox(fm: NgForm, editIndex: any) {
    this.getQuestionID();

    let dataExpression = 0;
    if (fm.value.inputType == 'email') {
      dataExpression = 9;
    } else if (fm.value.inputType == 'number') {
      dataExpression = 6;
    } else if (fm.value.inputType == 'tel') {
      dataExpression = 10;
    } else if (fm.value.inputType == 'number2') {
      dataExpression = 19;
    } else if (fm.value.inputType == 'dunsNumber') {
      dataExpression = 13;
    } else if (fm.value.inputType == 'naics') {
      dataExpression = 16;
    } else if (fm.value.inputType == 'text') {
      dataExpression = 999;
    } else if (fm.value.inputType == 'cageCode') {
      dataExpression = 14;
    }
    let textboxhtmlcontent = ``;
    if (fm.value.inputType == '') {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:` +
        fm.value.align +
        `'><input type="text" id='textboxID_` +
        this.QuestionID +
        `' data-expression='` +
        dataExpression +
        `' min='` +
        fm.value.minLength +
        `' max='` +
        fm.value.maxLength +
        `' ></input></div><br>`;
    } else if (fm.value.inputType == 'number2') {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:${fm.value.align}'>
      <input type='number' data-expression="${dataExpression}" min="${fm.value.minLength}" max ="${fm.value.maxLength}" id="textboxID_${this.QuestionID}"></input>
      </div><br>`;
    } else if (fm.value.inputType == 'number') {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:${fm.value.align}'>
      <input type='number' data-expression="${dataExpression}" min="${fm.value.minLength}" max ="${fm.value.maxLength}" id="textboxID_${this.QuestionID}"></input>
      </div><br>`;
    } else {
      textboxhtmlcontent =
        textboxhtmlcontent +
        `<div style='text-align:${fm.value.align}'>
        <input type='${fm.value.inputType}' id='textboxID_${this.QuestionID
        }' data-expression='${dataExpression}' ${fm.value.minLength ? `min='${fm.value.minLength}'` : ''
        } ${fm.value.maxLength ? `max ='${fm.value.maxLength}'` : ''}></input>
        </div><br>
        `;
    }
    this.sanitizer.bypassSecurityTrustHtml(textboxhtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(textboxhtmlcontent),
        displaytext: 'textbox',
        textboxdata: this.textboxitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'textbox',
        alignment: fm.value.align,
        inputType: fm.value.inputType ? fm.value.inputType : 'text',
        minLength: fm.value.minLength,
        maxLength: fm.value.maxLength,
        dataExpression: dataExpression,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(textboxhtmlcontent),
        displaytext: 'textbox',
        textboxdata: this.textboxitemLists,
        QuestionId: this.QuestionID,
        index: this.formData.length + 1,
        type: 'textbox',
        alignment: fm.value.align,
        inputType: fm.value.inputType ? fm.value.inputType : 'text',
        minLength: fm.value.minLength,
        maxLength: fm.value.maxLength,
        dataExpression: dataExpression,
      });
    }
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("Submit Text box successful");
  }

  // popup remove by clicking cancel button
  modalRemove() {
    this.isSubmitter = false;
    this.isDragablelistDisable = false;
    this.selectedSectionIndex = null;
    this.selectedQuestionPreview = null;
    this.previewSectionUniqueID = null;
    // On Submit Element
    this.modalService.dismissAll();
  }

  isSubmitter = false;
  isSubmitterdisabled = false;
  isSubmitterSaved = true;
  isOtherQuestiosSaved = true;
  hasSubmitter = false;
  hideForm() {
    this.isSubmitter = false;
    this.isSaved = false;
    this.isDragablelistDisable = false;
    this.isSubmitterdisabled = false;
    this.sections.Section.sort((a, b) => a.Sequence - b.Sequence);
    this.QuestionID = '';
    for (let i = 0; i < this.formData.length; i++) {

      if (this.formData[i].type != 'Submitter') {
        this.isOtherQuestiosSaved = false;
      }
      if (this.formData[i].type == 'checkbox') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'CheckBox',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          checkboxdata: this.formData[i].checkboxdata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'dropdown') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'DropDownListSelection',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          dropdowndata: this.formData[i].dropdowndata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
          isDisableInputChecked:
            this.formData[i].isDisableInputChecked ?? false,
          isDefaultValueChecked:
            this.formData[i].isDefaultValueChecked ?? false,
        });
      } else if (this.formData[i].type == 'multiselect-dropdown') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'DropDownListSelection',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          multiselectDropdowndata: this.formData[i].multiselectDropdowndata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'radio') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'RadioButton',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          radiodata: this.formData[i].radiodata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'date') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'Date',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          datedata: this.formData[i].datedata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          isBetweenSelected: this.formData[i].isBetweenSelected,
          isFutureDateAllowed: this.formData[i].isFutureDateAllowed,
          maxFutureMonth: this.formData[i].maxFutureMonth,
          minPastMonth: this.formData[i].minPastMonth,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'textarea') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'TextArea',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          textareadata: this.formData[i].textareadata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          isHidden: this.formData[i].isHidden,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'textbox') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: this.formData[i].QuestionId,
          TypeValue: 'TextInput',
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          textboxdata: this.formData[i].textboxdata,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,

          inputType: this.formData[i].inputType,
          minLength: this.formData[i].minLength,
          maxLength: this.formData[i].maxLength,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'guidance') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt
          ),
          QuestionId: this.formData[i].QuestionId,
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'text') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt
          ),
          QuestionId: this.formData[i].QuestionId,
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          isShortText: this.formData[i].isShortText,
          dispalyFCText: this.formData[i].dispalyFCText,
          mouseOverText: this.formData[i].mouseOverText,
          mappableCheck: this.formData[i].mappableCheck,
          fieldType: this.formData[i].fieldType,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'viewField') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: uuid(),
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'file') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity
          ),
          QuestionId: uuid(),
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          file: this.formData[i].file,
          fileData: this.formData[i].fileData,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'date') {
        this.previewData.push({
          question: this.sanitizer.bypassSecurityTrustHtml(
            this.formData[i].divcontnt
          ),
          QuestionId: this.formData[i].QuestionId,
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          alignment: this.formData[i].alignment,
          isFutureDateAllowed: this.formData[i].isFutureDateAllowed,
          isBetweenSelected: this.formData[i].isBetweenSelected,
          minPastMonth: this.formData[i].minPastMonth,
          maxFutureMonth: this.formData[i].maxFutureMonth,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });
      } else if (this.formData[i].type == 'Submitter') {
        this.hasSubmitter = true;
        this.isSubmitterSaved = false;
        this.isSubmitter = true;
        this.isSubmitterdisabled = true;
        let submitterdata = [];
        let content: any;
        let textcontent: any;
        if (
          this.formData[i].divcontnt['changingThisBreaksApplicationSecurity']
        ) {
          content =
            this.formData[i].divcontnt.changingThisBreaksApplicationSecurity;
        } else {
          content = this.formData[i].divcontnt;
        }
        if (
          this.formData[i].textdivcontnt[
          'changingThisBreaksApplicationSecurity'
          ]
        ) {
          textcontent =
            this.formData[i].textdivcontnt
              .changingThisBreaksApplicationSecurity;
        } else {
          textcontent = this.formData[i].textdivcontnt;
        }
        submitterdata.push({
          questionlabel: this.sanitizer.bypassSecurityTrustHtml(content),
          questionInput: this.sanitizer.bypassSecurityTrustHtml(textcontent),
          TypeValue: 'Submitter',
          QuestionId: this.formData[i].QuestionId,
          displayText: this.formData[i].displaytext,
          type: this.formData[i].type,
          value: this.formData[i].value,
          isShortText: this.formData[i].isShortText,
          dispalyFCText: this.formData[i].dispalyFCText,
          mouseOverText: this.formData[i].mouseOverText,
          alignment: this.formData[i].alignment,
          inputType: this.formData[i].inputType,
          minLength: this.formData[i].minLength,
          maxLength: this.formData[i].maxLength,
          dataExpression: this.formData[i].dataExpression ?? 0,
        });

        this.addformData.find((item) => item.displayquestion == 'Submitter');
        let showSubmitter = false;
        if (i == 0) {
          showSubmitter = true;
          this.addformData = this.addformData.filter(
            (item) => item.displayquestion !== 'Submitter'
          );
        }
        this.qcount++;
        let addformDatalength =
          this.addformData?.filter(
            (item) => item.displayquestion == 'Submitter'
          ).length + 1 || 1;
        this.addformData.push({
          data: submitterdata,
          displayquestion: 'Submitter',
          qcount: addformDatalength,
          sectionId: this.isSection
            ? localStorage.getItem('SubSectionId')
              ? this.activeSubSection.UniqueID
              : this.activeSection.UniqueID
            : this.currentSectionID,
          ShowSubmitter: showSubmitter,
        });
        this.updateShow = false;
        this.addToFormShow = true;
      }
    }

    if (!this.isSubmitter) {
      if (this.editFormindex >= 0) {
        this.addformData.splice(this.editFormindex, 1, {
          data: this.previewData,
          displayquestion: `Question${this.editQuesQcount}`,
          qcount: this.editQuesQcount,
          sectionId: this.isSection
            ? localStorage.getItem('SubSectionId')
              ? this.activeSubSection?.UniqueID
              : this.activeSection?.UniqueID
            : this.currentSectionID,
        });
        this.updateShow = false;
        this.addToFormShow = true;
      } else {
        this.qcount++;
        let addformDatalength =
          this.addformData?.filter(
            (item) => item.displayquestion != 'Submitter'
          ).length + 1 || 1;
        this.addformData.push({
          data: this.previewData,
          displayquestion: `Question${addformDatalength}`,
          qcount: addformDatalength,
          sectionId: this.isSection
            ? localStorage.getItem('SubSectionId')
              ? this.activeSubSection?.UniqueID
              : this.activeSection?.UniqueID
            : this.currentSectionID,
        });
        this.updateShow = false;
        this.addToFormShow = true;
      }
    }
    this.formData = [];
    this.previewData = [];
    this.localStorageService.setToLocalStroage('ADDFORMDATA', this.addformData);

    this.resetAllModalRefs();
  }

  private _helper$: Subject<string> = new Subject();
  public get helper(): Observable<string> {
    return this._helper$.asObservable();
  }
  public set helper(value: string) {
    this._helper$.next(value);
  }

  editFormdesigner(Sectionid: any) {
    this.apiService
      .GetSections()
      .pipe(
        map((res) => {
          this.addformData = [];
          this.sections = new Sections();
          let sectionDtails = res.Data.filter(
            (item) => item.Title !== 'Submitter'
          );

          if (Boolean(this.formLayout?.toLowerCase() !== 'multiple')) {
            this.submitterSections =
              res.Data?.filter((section) => section.Title === 'Submitter') ??
              [];
            if (this.submitterSections?.length) {
              localStorage.setItem(
                'submitterSections',
                JSON.stringify(this.submitterSections)
              );
            }
          }
          this.helper = 'submitter sections updated';

          localStorage.setItem('SectionId', sectionDtails[0].UniqueID);
          return res.Data.map((element) => element.UniqueID);
        }),
        switchMap((sectionIdsArr) =>
          forkJoin(
            sectionIdsArr.map((sectionId) =>
              this.apiService.GetSectionDetails(sectionId)
            )
          )
        ),
        catchError((e: any) => {
          return throwError(() => new Error(e));
        })
      )
      .subscribe({
        next: (sectionsResp: any) => {

          sectionsResp.forEach((sectionResp) => {
            this.sections['Section'] = sectionsResp
              .map((s) => s.Data)
              .filter((s) => !s.ParentID);
            if (sectionResp?.Data?.ParentID && this.sections?.Section?.length) {
              const parentSecIdx = this.sections?.Section?.findIndex(
                (parentSec) =>
                  parentSec?.UniqueID === sectionResp?.Data?.ParentID
              );
              this.sections.Section[parentSecIdx]?.Sections?.forEach(
                (subSec, idx) => {
                  if (subSec?.UniqueID === sectionResp?.Data?.UniqueID) {
                    this.sections.Section[parentSecIdx].Sections[idx] =
                      sectionResp?.Data;
                  }
                }
              );
            }
            this.handleEachSectionResp(sectionResp)
          }

          );
        },
        error: () => { },
      });
  }


  sortAllFields(response: any) {
    response.forEach(element => {
      if (element?.Data?.Fields) {
        element.Data.Fields = element?.Data?.Fields?.sort(
          (field1, field2) => field1?.DisplayOrder - field2?.DisplayOrder
        );
      }
    });

  }

  handleEachSectionResp(response: any) {
    if (response.Data != null) {
      if (response?.Data?.Fields) {
        response.Data.Fields = response?.Data?.Fields?.sort(
          (field1, field2) => field1?.DisplayOrder - field2?.DisplayOrder
        );
      }
      this.edidMapdata = [response.Data];

      let sectionInfo = new SectionInfo();
      sectionInfo = response.Data;
      this.sections.Section.push(sectionInfo);
      this.sections.Section = Array.from(
        new Map(this.sections.Section.map((item) => [item.UniqueID, item])).values()
      );
      let sectionData: Sections[] = [];
      sectionData.push(this.sections);
      localStorage.setItem('AllQuestions', JSON.stringify(sectionData));

      let Question: any = [];
      Question = this.reverseObjectMapper(this.edidMapdata);
      if (Question.length) {
        Question.forEach((e) => {
          this.addformData.push(e);
        });
      }
    }
  }

  prepareMultiSectionFormdesigner() {
    this.apiService
      .GetSections()
      .pipe(
        map((res) => {
          this.helper = 'submitter sections updated';
          return res.Data.map((element) => element.UniqueID);
        }),
        switchMap((sectionIdsArr) =>
          forkJoin(
            sectionIdsArr.map((sectionId) =>
              this.apiService.GetSectionDetails(sectionId)
            )
          )
        ),
        catchError((e: any) => {
          return throwError(() => new Error(e));
        })
      )
      .subscribe({
        next: (sectionsResp: any) => {
          this.sections['Section'] = sectionsResp
            .map((s) => s?.Data)
            .filter((s) => s && !s.ParentID);
          sectionsResp?.forEach((sectionResp) => {
            this.sortAllFields(sectionsResp)
            if (sectionResp?.Data?.ParentID && this.sections?.Section?.length) {
              const parentSecIdx = this.sections?.Section?.findIndex(
                (parentSec) =>
                  parentSec?.UniqueID === sectionResp?.Data?.ParentID
              );
              const parentSec = this.sections?.Section?.find(
                (parentSec) =>
                  parentSec?.UniqueID === sectionResp?.Data?.ParentID
              );
              this.sections.Section[parentSecIdx]?.Sections?.forEach(
                (subSec, idx) => {
                  if (subSec?.UniqueID === sectionResp?.Data?.UniqueID) {
                    this.sections.Section[parentSecIdx].Sections[idx] =
                      sectionResp?.Data;
                  }
                }
              );
            }
          });
          this.activeSection = this.sections?.Section?.[0];
          this.activeSubSection = this.sections?.Section?.[0]?.Sections?.[0];
          if (this.activeSection && this.activeSubSection) {
            this.isDragablelistDisable = false;
          }
          if (this.activeSection?.UniqueID)
            localStorage.setItem('SectionId', this.activeSection?.UniqueID);
          if (this.activeSubSection?.UniqueID)
            localStorage.setItem(
              'SubSectionId',
              this.activeSubSection?.UniqueID
            );
          localStorage.setItem('AllQuestions', JSON.stringify([this.sections]));

          const fields = this.reverseObjectMapper(
            sectionsResp?.map((x) => x.Data)
          );
          this.addformData = fields.length ? [...fields] : [];

          this.triggerGetConditionaDetails();
        },
        error: () => { },
      });
  }

  getHtmlElementAlignment(htmlElement): string {
    const alignments = ['right', 'center'];
    for (const alignment of alignments) {
      if (
        htmlElement.AnswerHtml?.trim()?.includes(
          `style='text-align:${alignment}'`
        ) ||
        htmlElement.AnswerHtml?.trim()?.includes(
          `style="text-align:${alignment}"`
        )
      ) {
        return alignment;
      }
    }
    return `left`;
  }

  getTextBoxInputType(textBoxElement): string {
    const dataExpressions = {
      email: 9,
      number: 6,
      tel: 10,
      number2: 19,
      dunsNumber: 13,
      naics: 16,
      text: 999,
      cageCode: 14,
    };
    if (
      textBoxElement.AnswerHtml &&
      textBoxElement.AnswerHtml?.includes(`input`) &&
      textBoxElement.AnswerHtml?.includes(`data-expression`)
    ) {
      for (const [deKey, deVal] of Object.entries(dataExpressions)) {
        if (
          textBoxElement.AnswerHtml?.trim()?.includes(
            `data-expression="${deVal}"`
          ) ||
          textBoxElement.AnswerHtml?.trim()?.includes(
            `data-expression='${deVal}'`
          )
        ) {
          return deKey;
        }
      }
    }
    return `password`;
  }

  getTextBoxAlignment(textBoxElement): string {
    const alignments = ['right', 'center'];
    for (const alignment of alignments) {
      if (
        textBoxElement.AnswerHtml?.trim()?.includes(
          `style='text-align:${alignment}'`
        ) ||
        textBoxElement.AnswerHtml?.trim()?.includes(
          `style="text-align:${alignment}"`
        )
      ) {
        return alignment;
      }
    }
    return `left`;
  }

  reverseObjectMapper(EdidMapdata: any) {
    let Question: any = [];
    let temparray: any = [];
    let QuestionDsiplayorder = 1;
    EdidMapdata.forEach((ele) => {
      let count = 0;
      ele.Fields.forEach((element: any, i: any) => {
        temparray = [];

        if (!this.isSection && ele.Title == 'Submitter') {
          temparray.push({
            questionlabel: {
              changingThisBreaksApplicationSecurity: element.QuestionHtml,
            },
            questionInput: {
              changingThisBreaksApplicationSecurity: element.AnswerHtml,
            },
            TypeValue: 'Submitter',
            alignment: undefined,
            inputType: 'text',
            QuestionId: element.UniqueID,
            dataExpression: element.Expression ?? 0,
            displayText: 'Label',
            type: 'Submitter',
            value: element.Label,
            isShortText: false,
            dispalyFCText: (element.Name || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
            mouseOverText: element.HelpContent || '',
          });
          if (count == 0) {
            Question.push({
              data: temparray,
              displayquestion: 'Submitter',
              qcount: i,
              sectionId: ele.UniqueID,
              ShowSubmitter: true,
            });
            count++;
          } else {
            Question.push({
              data: temparray,
              displayquestion: 'Submitter',
              qcount: i,
              sectionId: ele.UniqueID,
              ShowSubmitter: false,
            });
          }
        } else {
          let optionsArray: {
            id: any;
            answer: any;
            selected: boolean;
            optionid: string;
          }[] = [];
          if (element.Options) {
            element.Options.forEach(
              (e: { OptionValue: any; UniqueID: string }, index: any) => {
                optionsArray.push({
                  id: index,
                  optionid: e.UniqueID,
                  answer: e.OptionValue,
                  selected: false,
                });
              }
            );
          }
          let displayText = '';
          let type = '';
          let inputType = '';
          let QuestionID = '';
          let isHidden: boolean = false;
          let isBetweenSelected = false;
          let isFutureDateAllowed = false;
          let isDisableInputChecked = false;
          let isDefaultValueChecked = false;
          let minPastMonth = 0;
          let maxFutureMonth = 0;
          let minLength;
          let maxLength;
          let alignment = '';
          if (element.Type == 'DropDownListSelection') {
            displayText = 'dropdownButton';
            type = 'dropdown';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
            isDisableInputChecked =
              element.AnswerHtml?.trim()?.includes(`disabled`) ||
              element.AnswerHtml?.trim()?.includes(`disabled="true"'`) ||
              element.AnswerHtml?.trim()?.includes(`disabled='true''`);
            isDefaultValueChecked = false;
          }
          if (
            element.Type == 'DropDownListSelection' &&
            element.AnswerHtml?.includes(`multiple`) &&
            (element.AnswerHtml?.trim()?.includes(`multiple="true"`) ||
              element.AnswerHtml?.trim()?.includes(`multiple='true'`))
          ) {
            displayText = 'multiselectDropdownButton';
            type = 'multiselect-dropdown';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'CheckBox') {
            displayText = 'checkboxButton';
            type = 'checkbox';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'RadioButton') {
            displayText = 'RadioButton';
            type = 'radio';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'TextArea') {
            displayText = '';
            type = 'textarea';
            QuestionID = element.UniqueID;
            isHidden =
              element.AnswerHtml?.trim()?.includes(`style="display:none"`) ||
              element.AnswerHtml?.trim()?.includes(`style='display:none'`);
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'TextInput') {
            displayText = '';
            type = 'textbox';
            inputType = this.getTextBoxInputType(element);
            minLength = element.MinChar;
            maxLength = element.MaxChar;
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'Date') {
            displayText = '';
            type = 'date';
            QuestionID = element.UniqueID;
            isBetweenSelected = element.MinPeriod !== null;
            isFutureDateAllowed = element.MaxPeriod !== null;
            minPastMonth = element.MinPeriod;
            maxFutureMonth = element.MaxPeriod;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.Type == 'Attachment') {
            displayText = '';
            type = 'file';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }
          if (element.type == 'text') {
            displayText = '';
            type = 'text';
            QuestionID = element.UniqueID;
            alignment = this.getHtmlElementAlignment(element);
          }

          if (!element.GuidanceText && !element.GuidanceHtml) {
            temparray.push(
              {
                displayText: 'Label',
                type: 'text',
                value: element.Label,
                isShortText: false,
                dispalyFCText: (element.Name || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
                QuestionId: QuestionID,
                mouseOverText: element.HelpContent || '',
                mappableCheck: element.IsMappable,
                fieldType: element.FieldType,
                question: {
                  changingThisBreaksApplicationSecurity: element.QuestionHtml,
                },
                dataExpression: element.Expression ?? 0,
                inputType: inputType,
                alignment: alignment,
              },
              {
                question: {
                  changingThisBreaksApplicationSecurity: element.AnswerHtml,
                },
                QuestionId: QuestionID,
                TypeValue: element.Type,
                displayText: displayText,
                type: type,
                dropdowndata: optionsArray,
                multiselectDropdowndata: optionsArray,
                checkboxdata: optionsArray,
                radiodata: optionsArray,
                dataExpression: element.Expression ?? 0,
                isHidden: isHidden,
                isDisableInputChecked: isDisableInputChecked,
                isDefaultValueChecked: isDefaultValueChecked,
                isBetweenSelected: isBetweenSelected,
                isFutureDateAllowed: isFutureDateAllowed,
                minPastMonth: minPastMonth,
                maxFutureMonth: maxFutureMonth,
                inputType: inputType,
                minLength: minLength,
                maxLength: maxLength,
                alignment: alignment,
              }
            );
          } else {
            temparray.push(
              {
                displayText: 'Label',
                type: 'text',
                value: element.Label,
                QuestionId: QuestionID,
                isShortText: false,
                dispalyFCText: (element.Name || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
                mouseOverText: element.HelpContent || '',
                mappableCheck: element.IsMappable,
                fieldType: element.FieldType,
                question: {
                  changingThisBreaksApplicationSecurity: element.QuestionHtml,
                },
                dataExpression: element.Expression ?? 0,
              },
              {
                question: {
                  changingThisBreaksApplicationSecurity: element.AnswerHtml,
                },
                QuestionId: QuestionID,
                TypeValue: element.Type,
                displayText: displayText,
                type: type,
                dropdowndata: optionsArray,
                multiselectDropdowndata: optionsArray,
                checkboxdata: optionsArray,
                radiodata: optionsArray,
                dataExpression: element.Expression ?? 0,
                isHidden: isHidden,
                isDisableInputChecked: isDisableInputChecked,
                isDefaultValueChecked: isDefaultValueChecked,
                isBetweenSelected: isBetweenSelected,
                isFutureDateAllowed: isFutureDateAllowed,
                minPastMonth: minPastMonth,
                maxFutureMonth: maxFutureMonth,
                inputType: inputType,
                minLength: minLength,
                maxLength: maxLength,
                alignment: alignment,
              },
              {
                question: {
                  changingThisBreaksApplicationSecurity: element.GuidanceHtml,
                },
                QuestionId: QuestionID,
                displayText: element.GuidanceText ?? '',
                type: 'guidance',
                alignment: element.GuidanceText.split(':::')[0].includes(
                  'vertical'
                )
                  ? 'vertical'
                  : 'horizontal',
                dataExpression: element.Expression ?? 0,
              }
            );
          }

          Question.push({
            data: temparray,
            displayquestion: `Question${i}`,
            qcount: QuestionDsiplayorder,
            sectionId: ele.UniqueID,
          });
          QuestionDsiplayorder++;
        }
      });
    });

    return Question;
  }

  cloneQuestionComponent(
    questionId: any = null,
    section: any,
    sectionIndex: number = null,
    isSubmitter: boolean
  ) {
    if (!this.isSaved) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please save the question before creating a clone of it',
        icon: 'warning',
      });
      return;
    }
    const allSectionData =
      JSON.parse(localStorage.getItem('AllQuestions'))?.[0] ?? this.sections;
    const allSections = [...allSectionData?.Section];

    // START: Fetch field to be cloned
    let fieldToBeCloned: IField;

    // if selected item is a section
    if (this.activeSection && !this.activeSubSection) {
      fieldToBeCloned = this.getFieldById(
        this.activeSection?.Fields,
        questionId
      );
    }
    // if selected item is a sub section of a section
    else if (this.activeSection && this.activeSubSection) {
      fieldToBeCloned = this.getFieldById(
        this.activeSubSection?.Fields,
        questionId
      );
    }
    // END: Fetch field to be cloned

    const activeSecIdx = this.sections?.Section?.findIndex(
      (sec) => sec?.UniqueID === this.activeSection?.UniqueID
    );
    const activeSubSecIdx = this.sections?.Section[
      activeSecIdx
    ].Sections.findIndex(
      (sec) => sec?.UniqueID === this.activeSubSection?.UniqueID
    );

    // START: Fetch field to be cloned
    let questionIndex;
    // if selected item is a section
    if (this.activeSection && !this.activeSubSection) {
      questionIndex = this.activeSection?.Fields?.findIndex(
        (f) => f?.UniqueID === questionId
      );
    }
    // if selected item is a sub section of a section
    else if (this.activeSection && this.activeSubSection) {
      questionIndex = this.activeSubSection?.Fields?.findIndex(
        (f) => f?.UniqueID === questionId
      );
    }
    // End: Fetch field to be cloned

    let clone = { ...fieldToBeCloned };

    const fieldToBeClonedId = fieldToBeCloned?.UniqueID;

    const newCloneId = uuid();
    const newCloneName = `${fieldToBeCloned.Name} - copy`;
    const newCloneDisplayOrder = Number(fieldToBeCloned.DisplayOrder) + 1;
    const newCloneOptions = fieldToBeCloned?.Options
      ? [...fieldToBeCloned?.Options].map((opt) => ({
        ...opt,
        UniqueID: uuid(),
      }))
      : [];

    const newCloneAnswerHTML = this.fieldCloner.cloneAnswerHTML(
      fieldToBeCloned,
      newCloneOptions
    );

    clone = {
      ...clone,
      AnswerHtml: newCloneAnswerHTML,
      DisplayOrder: newCloneDisplayOrder,
      Name: newCloneName,
      Options: newCloneOptions,
    };
    clone = JSON.parse(
      JSON.stringify(clone).replaceAll(fieldToBeClonedId, newCloneId)
    );

    // if selected item is a section - splice section fields
    if (this.activeSection && !this.activeSubSection) {
      this.sections.Section[activeSecIdx]['Fields'].splice(
        questionIndex + 1,
        0,
        clone
      );
    }
    // if selected item is a sub section of a section - splice subsection fields
    else if (this.activeSection && this.activeSubSection) {
      this.sections.Section[activeSecIdx].Sections[activeSubSecIdx][
        'Fields'
      ].splice(questionIndex + 1, 0, clone);
    }

    localStorage.setItem('AllQuestions', JSON.stringify(this.sections));

    let fields;

    // if selected item is a section - splice section fields
    if (this.activeSection && !this.activeSubSection) {
      fields = this.reverseObjectMapper(this.sections.Section);
    }
    // if selected item is a sub section of a section - splice subsection fields
    else if (this.activeSection && this.activeSubSection) {
      fields = this.reverseObjectMapper(
        this.sections.Section[activeSecIdx].Sections
      );
    }
    this.addformData = fields.length ? [...fields] : [];
    this.isSaved = false;
  }

  getFieldByIdx(fieldData: any[], indx: number) {
    return fieldData.find((e, ix) => ix === indx);
  }

  getFieldById(fieldData: any[], questionId: string): IField {
    return fieldData?.find((field) => field?.UniqueID === questionId);
  }

  editquestionComponent(
    index: any,
    section: any,
    sectionIndex: number,
    isSubmitter: boolean
  ) {
    this.currentSectionID = section.UniqueID;
    this.isSubmitterdisabled = false;
    this.isDragablelistDisable = true;
    this.formData = [];
    this.addToFormShow = false;
    this.updateShow = true;
    this.editFormindex = index;
    this.editQuesQcount = this.addformData[index].qcount;
    if (
      this.addformData.filter((item) => item.displayquestion == 'Submitter')
        .length
    ) {
      this.isexpanded = false;
      this.isSubmitterdisabled = true;
    }

    if (isSubmitter) {
      this.isFormFieldUnsupported = false;
      this.hasSubmitter = false;
      this.isexpanded = true;
      this.isSubmitterdisabled = false;
      let submitterdata = [];
      submitterdata = this.addformData.filter(
        (item) => item.displayquestion == 'Submitter'
      );
      for (let i = 0; i < submitterdata.length; i++) {
        this.currentSectionID = submitterdata[0].sectionId;
        this.submitterSectionID = this.currentSectionID;

        submitterdata[i].data[0].displayText;
        let Textdivcontnt: any;
        let Divcontnt: any;
        if (
          submitterdata[i].data[0].questionInput[
          'changingThisBreaksApplicationSecurity'
          ]
        ) {
          Textdivcontnt =
            submitterdata[i].data[0].questionInput
              .changingThisBreaksApplicationSecurity;
        } else {
          Textdivcontnt = submitterdata[i].data[0].questionInput;
        }
        if (
          submitterdata[i].data[0].questionlabel[
          'changingThisBreaksApplicationSecurity'
          ]
        ) {
          Divcontnt =
            submitterdata[i].data[0].questionlabel
              .changingThisBreaksApplicationSecurity;
        } else {
          Divcontnt = submitterdata[i].data[0].questionlabel;
        }

        this.formData.push({
          textdivcontnt: Textdivcontnt,
          divcontnt: Divcontnt,
          displaytext: submitterdata[i].data[0].displayText,
          index: this.formData.length + 1,
          type: submitterdata[i].data[0].type,
          value: submitterdata[i].data[0].value,
          QuestionId: submitterdata[i].data[0].QuestionId,
          isShortText: submitterdata[i].data[0].isShortText,
          dispalyFCText: submitterdata[i].data[0].dispalyFCText,
          mouseOverText: submitterdata[i].data[0].mouseOverText,
          alignment: submitterdata[i].data[0].alignment,
          inputType: submitterdata[i].data[0].inputType,
          minLength: submitterdata[i].data[0].minLength,
          maxLength: submitterdata[i].data[0].maxLength,
        });
      }
    } else {
      this.isDragablelistDisable = false;
      for (let i = 0; i < this.addformData[index].data.length; i++) {
        if (this.addformData[index].data[i].type == 'checkbox') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            checkboxdata: this.addformData[index].data[i].checkboxdata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
          this.editcollectionIndex++;
        } else if (this.addformData[index].data[i].type == 'dropdown') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            dropdowndata: this.addformData[index].data[i].dropdowndata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
            isDisableInputChecked:
              this.addformData[index].data[i].isDisableInputChecked ?? false,
            isDefaultValueChecked:
              this.addformData[index].data[i].isDefaultValueChecked ?? false,
          });
        } else if (
          this.addformData[index].data[i].type == 'multiselect-dropdown'
        ) {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            multiselectDropdowndata:
              this.addformData[index].data[i].multiselectDropdowndata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'radio') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            radiodata: this.addformData[index].data[i].radiodata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'date') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            datedata: this.addformData[index].data[i].datedata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
            isBetweenSelected:
              this.addformData[index].data[i].isBetweenSelected,
            isFutureDateAllowed:
              this.addformData[index].data[i].isFutureDateAllowed,
            minPastMonth: this.addformData[index].data[i].minPastMonth,
            maxFutureMonth: this.addformData[index].data[i].maxFutureMonth,
          });
        } else if (this.addformData[index].data[i].type == 'textarea') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            textareadata: this.addformData[index].data[i].textareadata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            isHidden: this.addformData[index].data[i].isHidden,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'textbox') {
          this.formData.push({
            divcontnt: this.sanitizer.bypassSecurityTrustHtml(
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity
            ),
            QuestionId: this.addformData[index].data[i].QuestionId,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            textboxdata: this.addformData[index].data[i].textboxdata,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            inputType: this.addformData[index].data[i].inputType,
            minLength: this.addformData[index].data[i].minLength,
            maxLength: this.addformData[index].data[i].maxLength,
            dataExpression: this.addformData[index].data[i].dataExpression,
          });
        } else if (this.addformData[index].data[i].type == 'guidance') {
          this.formData.push({
            divcontnt:
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'text') {
          this.formData.push({
            divcontnt:
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity,
            displaytext: this.addformData[index].data[i].displayText,
            QuestionId: this.addformData[index].data[i].QuestionId,
            type: this.addformData[index].data[i].type,
            value: this.addformData[index].data[i].value,
            isShortText: this.addformData[index].data[i].isShortText,
            dispalyFCText: this.addformData[index].data[i].dispalyFCText,
            mouseOverText: this.addformData[index].data[i].mouseOverText,
            mappableCheck: this.addformData[index].data[i].mappableCheck,
            fieldType: this.addformData[index].data[i].fieldType,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'viewField') {
          this.formData.push({
            divcontnt:
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        } else if (this.addformData[index].data[i].type == 'file') {
          this.formData.push({
            divcontnt:
              this.addformData[index].data[i].question
                .changingThisBreaksApplicationSecurity,
            displaytext: this.addformData[index].data[i].displayText,
            type: this.addformData[index].data[i].type,
            value: this.addformData[index].data[i].value,
            alignment: this.addformData[index].data[i].alignment,
            file: this.addformData[index].data[i].file,
            fileData: this.addformData[index].data[i].fileData,
            dataExpression: this.addformData[index].data[i].dataExpression ?? 0,
          });
        }
      }
    }
  }

  isIdPresent(id: string): boolean {
    const isInSource = this.conditionalLogicData?.SectionConditions?.length
      ? this.conditionalLogicData.SectionConditions[0].ConditionalLogic.some(
        (condition) => condition.SourceQuestinID === id
      )
      : false;

    const isInDestination = this.conditionalLogicData?.SectionConditions?.length
      ? this.conditionalLogicData.SectionConditions[0].ConditionalLogic.some(
        (condition) =>
          condition.Conditions &&
          condition.Conditions.some(
            (innerCondition) => innerCondition.DestinationQuestionID === id
          )
      )
      : false;

    return isInSource || isInDestination;
  }
  isIdPresentInLinks(id: string): boolean {
    const isInSource = this.conditionalLogicData?.ChartJson
      ? JSON.parse(this.conditionalLogicData.ChartJson)[0].Links.some(
        (link) => link.source === id
      )
      : false;

    const isInDestination = this.conditionalLogicData?.ChartJson
      ? JSON.parse(this.conditionalLogicData.ChartJson)[0].Links.some(
        (link) => link.target === id
      )
      : false;

    return isInSource || isInDestination;
  }

  deletequestionComponent(index: any) {
    const isIdPresentInObject = this.isIdPresent(
      this.addformData[index].data[0].QuestionId
    );
    if (isIdPresentInObject) {
      const swalWithBootstrapButtons = swal.mixin({
        customClass: {
          confirmButton: 'btn',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Question is added in the conditional logic. If you want to delete the question please delete the Question from conditional logic.',
        icon: 'warning',
      });
    } else {
      if (confirm('Are you sure want to delete the question field?')) {
        this.addformData.splice(index, 1);
        this.isSection ? this.onNestedQuesSave() : this.onQuesSave(false, 1);
      }
    }
  }
  deletSubmitter(sectionID: any) {
    let sectiontodelete = this.sections.Section.filter(
      (item) => item.UniqueID == sectionID
    );
    this.sections.Section = this.sections.Section.filter(
      (item) => item.UniqueID !== sectionID
    );
    sectiontodelete[0]['UpdatedBy'] = {
      Name: '',
      Email: '',
      UPN: '',
      UniqueID: localStorage.getItem('UserId'),
    };
    this.apiService.DeleteSection(sectiontodelete[0]).subscribe(
      (Response) => {
        this.currentSectionID = localStorage.getItem('SectionId');
        if (Response.Success) {
          this.swalWithBootstrapButtons.fire({
            title: 'Success!',
            text: 'Submitter section deleted successfully',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          this.swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text:
              Response.Msg ||
              'An error occurred while deleting the Submitter section',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
      (err) => {
        this.swalWithBootstrapButtons.fire({
          title: 'Failure!',
          text: 'An error occurred while deleting the Submitter section',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    );
    this.isSubmitterdisabled = false;
    this.addformData = this.addformData.filter(
      (item) => item.sectionId !== sectionID
    );
    this.currentSectionID = localStorage.getItem('SectionId');
  }

  create_UUID() {
    let dt = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  masterdatacontent(masterDataText: any, masterDataID: any) {
    var inputdataDiv = document.createElement('div');
    var inputdatalabel = document.createElement('label');
    var inputdata = document.createElement('input');
    let text = masterDataText + ':';
    inputdataDiv.appendChild(inputdatalabel);
    inputdata.setAttribute(
      'style',
      'outline: none;margin-left: 3px;width: 200px;height: 30px;border-radius: 3px;border: 1px solid black;padding: 0px 10px;'
    );
    inputdatalabel.appendChild(document.createTextNode(text));
    inputdata.setAttribute('data-defaulttype', `Mdm`);
    let masterDataSpaceText = masterDataText.replace(/\s/g, '');
    inputdata.setAttribute('data-defaultvalue', '' + masterDataSpaceText + '');
    inputdatalabel.append(inputdata);
    inputdata.type = 'text';
    var inputuniqueId = this.create_UUID();
    inputdata.id = inputuniqueId;
    this.formData.push({
      divcontnt: this.sanitizer.bypassSecurityTrustHtml(inputdataDiv.outerHTML),
      displaytext: masterDataText,
      type: 'viewField',
      FieldID: masterDataID,
    });
  }

  // clear the form preview

  clearQuesComponents() {
    this.isSubmitter = false;
    this.isDragablelistDisable = false;
    this.formData = [];
    this.updateShow = false;
    this.resetAllModalRefs();
  }

  objectMapper(element: any, questionOrder: any) {
    let optionVlaues = new OptionValues();
    let tempFormdata = new FormQuestions();
    element.forEach(
      (e: {
        type: string;
        value: string;
        mouseOverText: string;
        mappableCheck: boolean;
        fieldType: string;
        dispalyFCText: string;
        dropdowndata: any;
        multiselectDropdowndata: any;
        checkboxdata: any;
        radiodata: any;
        displayText: string;
        isShortText: boolean;
        question: any;
        TypeValue: string;
        QuestionId: string;
        dataExpression: string;
        questionlabel: any;
        questionInput: any;
        minLength?: number;
        maxLength?: number;
        minPastMonth?: number;
        maxFutureMonth?: number;
        isBetweenSelected?: boolean;
        isFutureDateAllowed?: boolean;
      }) => {
        if (e.type != 'Submitter') {
          this.isOtherQuestiosSaved = true;
        }
        if (e.type == 'Submitter') {
          this.isSubmitterSaved = true;
          tempFormdata.Label = e.value;
          tempFormdata.HelpContent = e.mouseOverText;
          tempFormdata.Name = e.dispalyFCText;
          tempFormdata.isShortText = e.isShortText;
          tempFormdata.QuestionHtml =
            e.questionlabel.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
          tempFormdata.Type = 'TextInput';
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.AnswerHtml =
            e.questionInput.changingThisBreaksApplicationSecurity;
        }
        if (e.type == 'text') {
          tempFormdata.Label = e.value;
          tempFormdata.HelpContent = e.mouseOverText;
          tempFormdata.IsMappable = e.mappableCheck;
          tempFormdata.FieldType = e.fieldType;
          tempFormdata.Name = e.dispalyFCText;
          tempFormdata.isShortText = e.isShortText;
          tempFormdata.QuestionHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
          tempFormdata.Type = e.TypeValue;
          tempFormdata.UniqueID = e.QuestionId;
        }
        if (e.type == 'date') {
          tempFormdata.AnswerHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.Type = e.TypeValue;
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.DefaultValue = e.value;
          tempFormdata.DisplayOrder = questionOrder;
          tempFormdata.MinPeriod = e.isBetweenSelected ? e.minPastMonth : null;
          tempFormdata.MaxPeriod = e.isFutureDateAllowed
            ? e.maxFutureMonth
            : null;
        }
        if (e.type == 'file') {
          tempFormdata.AnswerHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.AnswerHtml =
            `<div style='text-align:` +
            e['alignment'] +
            `'><input  type="file" id="fileID_` +
            e.QuestionId +
            `"/><div style="margin-top: 8px; font-size: 13px; color: #333;"><b>Note:</b> Upload files in PDF, Word, and Excel formats, up to 5 MB.</div></div><br>`;
          tempFormdata.Type = 'Attachment';
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.DefaultValue = (!e['fileData'] || Object.keys(e['fileData']).length === 0) ? null : e['fileData'];
          tempFormdata.DisplayOrder = questionOrder;
        }
        if (e.type == 'checkbox' || e.type == 'dropdown' || e.type == 'radio') {
          tempFormdata.Type = e.TypeValue;
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.AnswerHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
          let tempValue = [];
          tempValue = e.dropdowndata || e.checkboxdata || e.radiodata;
          tempValue.forEach(
            (element: { answer: string; i: number; optionid: string }) => {
              let option = {
                UniqueID: element.optionid,
                OptionText: element.answer,
                OptionValue: element.answer,
                Score: '',
              };

              tempFormdata.Options.push(option);
            }
          );
        }
        if (e.type == 'multiselect-dropdown') {
          tempFormdata.Type = e.TypeValue;
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.AnswerHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
          let tempValue = [];
          tempValue = e.multiselectDropdowndata;
          tempValue.forEach(
            (element: { answer: string; i: number; optionid: string }) => {
              let option = {
                UniqueID: element.optionid,
                OptionText: element.answer,
                OptionValue: element.answer,
                Score: '',
              };

              tempFormdata.Options.push(option);
            }
          );
        }
        if (e.type == 'textarea' || e.type == 'textbox') {
          tempFormdata.Type = e.TypeValue;
          tempFormdata.UniqueID = e.QuestionId;
          tempFormdata.AnswerHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
          tempFormdata.Expression = Number(e.dataExpression);
          tempFormdata.MinChar = e.minLength;
          tempFormdata.MaxChar = e.maxLength;
        }
        if (e.type == 'guidance') {
          tempFormdata.GuidanceText = e.displayText;
          tempFormdata.GuidanceHtml =
            e.question.changingThisBreaksApplicationSecurity;
          tempFormdata.DisplayOrder = questionOrder;
        }
      }
    );
    return tempFormdata;
  }

  onQuesExtract() {
    this.extractedQuestion = localStorage.getItem('AllQuestions');
    this.extractedConditionalLogic = localStorage.getItem('ConditionalLogicData');

    const blob = new Blob([JSON.stringify({
      Questionnaire: JSON.parse(this.extractedQuestion || '{}'),
      ConditionalLogic: JSON.parse(this.extractedConditionalLogic || '{}')
    }, null, 2)], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${this.FormName}.json`;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  onImportJson() {
    this.modalQuestionImportResponse = this.modalService.open(this.JSONImportContent, {
      fullscreen: true,
      scrollable: true,
    });
  }

  isSaved = false;
  onQuesSave(isQuestionnavigatetoConditionalLogic: any, SaveCount: any) {
    this.isSaved = true;
    let sectionData: Sections[] = [];
    this.sections.Section.forEach((element) => {
      element.Fields = [];
    });
    let QuestionOrder = 0;
    let SubmitterOrder = 0;
    this.addformData.forEach((element: any) => {
      let qcount = 0;
      if (element.displayquestion == 'Submitter') {
        SubmitterOrder++;
        qcount = SubmitterOrder;
      } else {
        QuestionOrder++;
        qcount = QuestionOrder;
      }

      let tempdata = this.objectMapper(element.data, qcount);
      this.sections.Section.find(
        (item) => item.UniqueID == element.sectionId
      ).Fields.push(tempdata);
    });
    sectionData.push(this.sections);
    let inputSection = new SectionInfo();
    inputSection = this.sections.Section.find(
      (item) => item.UniqueID == this.currentSectionID
    );
    if (inputSection.UpdatedBy == null) {
      inputSection.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
    }
    this.currentSectionID = localStorage.getItem('SectionId');
    if (SaveCount == 1) {
      this.apiService.SaveSection(inputSection).subscribe(
        (response: any) => {
          if (!isQuestionnavigatetoConditionalLogic) {
            // Error Handling for SaveSection API
            if (response.Success && response.Msg === '') {
              this.isSaved = true;
              this.swalWithBootstrapButtons.fire({
                title: 'Success!',
                text: 'Questions saved successfully',
                icon: 'success',
                confirmButtonText: 'OK',
              });
            } else {
              const didWAFBlock =
                response.error &&
                response.error.text &&
                response.error.text.includes('support ID');
              if (didWAFBlock) {
                this.swalWithBootstrapButtons.fire({
                  title: 'Request rejected',
                  text: this.getWAFMessage(response.error.text),
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              } else {
                this.swalWithBootstrapButtons.fire({
                  title: 'Failure!',
                  text: 'An error occured while saving the data.',
                  icon: 'error',
                  confirmButtonText: 'OK',
                });
              }
            }
          }
        },
        (error: any) => {
          this.swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text: 'An error occured while saving the data.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      );
    }
    localStorage.setItem('AllQuestions', JSON.stringify(sectionData));

    this.resetAllModalRefs();
  }

  getWAFMessage(htmlText: string) {
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlText, 'text/html');
    return (
      Array.from(html?.body?.childNodes)
        ?.filter((child) => child?.nodeName?.includes('text'))
        ?.map((child) => child?.textContent)
        ?.join(' ') ?? 'An error occured while saving the data.'
    );
  }

  onNestedQuesSave() {

    let payload;
    // if selected item is a section
    if (this.activeSection && !this.activeSubSection) {
      const activeSectionFormFieldsData = this.addformData.filter(
        (f) => f.sectionId === this.activeSection.UniqueID
      );
      const activeSectionFieldsList = activeSectionFormFieldsData.map(
        (f, idx) => this.objectMapper(f.data, Number(idx + 1))
      );

      this.activeSection.Fields = activeSectionFieldsList;

      if (!this.activeSection?.UpdatedBy) {
        this.activeSection['UpdatedBy'] = {
          UniqueID: localStorage.getItem('UserId'),
        };
      }
      payload = this.activeSection;
    }
    // if selected item is a sub section of a section
    else if (this.activeSection && this.activeSubSection) {
      const activeSubSectionFormFieldsData = this.addformData.filter(
        (f) => f.sectionId === this.activeSubSection.UniqueID
      );
      const activeSubSectionFieldsList = activeSubSectionFormFieldsData.map(
        (f, idx) => this.objectMapper(f.data, Number(idx + 1))
      );

      this.activeSubSection.Fields = activeSubSectionFieldsList;

      if (!this.activeSubSection?.UpdatedBy) {
        this.activeSubSection['UpdatedBy'] = {
          UniqueID: localStorage.getItem('UserId'),
        };
      }
      payload = this.activeSubSection;
    }

    this.apiService.SaveSection(payload).subscribe(
      (response: any) => {
        if (response.Success && response.Msg === '') {
          this.isSaved = true;
          this.swalWithBootstrapButtons.fire({
            title: 'Success!',
            text: 'Questions saved successfully',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        } else {
          const didWAFBlock =
            response.error &&
            response.error.text &&
            response.error.text.includes('support ID');
          if (didWAFBlock) {
            this.swalWithBootstrapButtons.fire({
              title: 'Request rejected',
              text: this.getWAFMessage(response.error.text),
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else {
            this.swalWithBootstrapButtons.fire({
              title: 'Failure!',
              text: 'An error occured while saving the data.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        }
      },
      (error: any) => {
        if (!window.location.origin.includes('localhost')) {
          this.swalWithBootstrapButtons.fire({
            title: 'Failure!',
            text: 'An error occured while saving the data.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      }
    );

    localStorage.setItem(
      'AllQuestions',
      JSON.stringify([{ Section: this.sections.Section }])
    );

    this.resetAllModalRefs();
  }

  previewQuestionnaire() {
    const formType = this.isSection ? 'multi-section' : 'single-section';
    if (formType === 'single-section') {
      this.modalService.open(this.previewQuestionnaireContent, {
        size: 'xl',
        scrollable: true,
      });
    }
    if (formType === 'multi-section') {
      // open multi section form preview component
      this.modalService.open(this.multiSectionQuestionnairePreview, {
        fullscreen: true,
        scrollable: true,
      });
    }
  }

  private _formType = '';
  public get formType() {
    let localStorageFormType = localStorage.getItem('FormType');
    return (this._formType = localStorageFormType ?? '');
  }

  getSanitizedHtml(content: any) {
    let trustHtml;
    if (content.type == 'Submitter') {
      let htmltcontent = '';
      if (content.divcontnt['changingThisBreaksApplicationSecurity']) {
        htmltcontent = content.divcontnt.changingThisBreaksApplicationSecurity;
      } else {
        htmltcontent = content.divcontnt;
      }
      if (content.textdivcontnt['changingThisBreaksApplicationSecurity']) {
        htmltcontent =
          htmltcontent +
          content.textdivcontnt.changingThisBreaksApplicationSecurity;
      } else {
        htmltcontent = htmltcontent + content.textdivcontnt;
      }
      trustHtml = this.sanitizer.bypassSecurityTrustHtml(htmltcontent);
    } else {
      if (content.divcontnt['changingThisBreaksApplicationSecurity']) {
        trustHtml = this.sanitizer.bypassSecurityTrustHtml(
          content.divcontnt.changingThisBreaksApplicationSecurity
        );
      } else {
        trustHtml = this.sanitizer.bypassSecurityTrustHtml(content.divcontnt);
      }
    }

    return trustHtml;
  }
  isContainsMasterData(quesData: any) {
    return quesData.data.some((quesdata: any) => quesdata.type == 'viewField');
  }

  getQuestionLable(quesData: any) {
    let label;
    let quesTextFound = quesData.data.filter(
      (quesdata: any) => quesdata.type == 'text'
    );

    if (quesTextFound && quesTextFound.length > 0) {
      if (quesTextFound[0].dispalyFCText) {
        label =
          quesTextFound[0].dispalyFCText.length > 12
            ? quesTextFound[0].dispalyFCText.substring(0, 12) + '...'
            : quesTextFound[0].dispalyFCText;
      } else {
        label =
          quesTextFound[0].value.length > 12
            ? quesTextFound[0].value.substring(0, 12) + '...'
            : quesTextFound[0].value;
      }
    } else if (quesData.data[0].type == 'Submitter') {
      label = 'Submitter';
    } else {
      label = quesData.displayquestion;
    }
    return label;
  }

  isActiveField(quesData) {
    return this.formData?.[0]?.QuestionId === quesData?.data?.[0]?.QuestionId;
  }

  getTitle(quesData: any) {
    let title;
    let quesTextFound = quesData.data.filter(
      (quesdata: any) => quesdata.type == 'text'
    );
    if (quesTextFound && quesTextFound.length > 0) {
      title = quesTextFound[0].mouseOverText;
    } else {
      title = '';
    }
    return title;
  }

  onBtnClick() {
    localStorage.setItem('addformData', JSON.stringify(this.addformData));
    this.router.navigateByUrl('/questions', {});
  }

  onKeyup() {
    if (this.isShortText) {
      const parser = new DOMParser();
      const html = parser.parseFromString(
        this.guidanceRef.htmlContent,
        'text/html'
      );
      let txtLength = html.body.textContent ? html.body.textContent.length : 0;
      if (txtLength && txtLength >= 60) {
        this.config.editable = false;
      }
    }
  }

  isSectionsListCollapsed = true;
  toggleSectionsList() {
    this.isSectionsListCollapsed = !this.isSectionsListCollapsed;
  }

  isSubSectionsListCollapsed = true;
  toggleSubSectionsList() {
    this.isSubSectionsListCollapsed = !this.isSubSectionsListCollapsed;
  }

  expandedSections: string[] = [];
  expandSubSectionsFor(section, secIdx) {
    if (
      this.expandedSections?.length &&
      this.expandedSections?.includes(section.UniqueID)
    ) {
    } else {
      this.expandedSections?.push(this.sections?.Section?.[secIdx]?.UniqueID);
    }
  }
  collapseSubSectionsFor(section, secIdx) {
    if (
      this.expandedSections?.length &&
      this.expandedSections?.includes(section.UniqueID)
    ) {
      const removeIdx = this.expandedSections?.findIndex(
        (id) => id === section?.UniqueID
      );
      this.expandedSections?.splice(removeIdx, 1);
    }
  }

  dropFormContainer(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.addformData, event.previousIndex, event.currentIndex);
    this.addformData.map(
      (formData: any, index: number) => (formData.qcount = index + 1)
    );
  }

  dropzoneContainer(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.formData, event.previousIndex, event.currentIndex);
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);
  }

  dropSectionContainer(event: CdkDragDrop<string[]>) {
    this.isSaved = false;
    moveItemInArray(
      this.sections.Section,
      event.previousIndex,
      event.currentIndex
    );
    this.sections.Section[event.currentIndex].Sequence =
      Number(event.currentIndex) + 1;
    this.sections.Section[event.previousIndex].Sequence =
      Number(event.previousIndex) + 1;

    if (!this.isSaved) {
      this.saveAllSections();
    }
  }
  saveAllSections() {
    this.sections.Section.forEach((sec, idx) => {
      sec.Sequence = idx + 1;
      if (!sec.UpdatedBy) {
        sec.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
      }
      this.apiService.SaveSection(sec).subscribe({
        next: (resp) => {
          this.isSaved = true;

          if (Number(this.sections?.Section?.length) - 1 === idx) {
            this.swalWithBootstrapButtons.fire({
              title: 'Success!',
              text: 'Sections rearranged successfully',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (err) => {
          if (window.location.origin.includes('localhost')) {
            this.isSaved = true; // To bypass Save warning in localhost
            if (Number(this.sections?.Section?.length) - 1 === idx) {
              this.swalWithBootstrapButtons.fire({
                title: 'Success!',
                text: 'Sections rearranged successfully',
                icon: 'success',
                confirmButtonText: 'OK',
              });
            }
          } else {
            this.swalWithBootstrapButtons.fire({
              title: 'Failure!',
              text: 'An error occured while rearranging the sections.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
      });
    });
  }
  saveAllSubSections() {
    this.activeSection.Sections.forEach((subSec, idx) => {
      subSec.Sequence = idx + 1;
      if (!subSec.UpdatedBy) {
        subSec.UpdatedBy = { UniqueID: localStorage.getItem('UserId') };
      }
      this.apiService.SaveSection(subSec).subscribe({
        next: (resp) => {
          this.isSaved = true;

          if (Number(this.activeSection?.Sections?.length) - 1 === idx) {
            this.swalWithBootstrapButtons.fire({
              title: 'Success!',
              text: 'Sub-sections rearranged successfully',
              icon: 'success',
              confirmButtonText: 'OK',
            });
          }
        },
        error: (err) => {
          if (window.location.origin.includes('localhost')) {
            this.isSaved = true; // To bypass Save warning in localhost
            if (Number(this.activeSection?.Sections?.length) - 1 === idx) {
              this.swalWithBootstrapButtons.fire({
                title: 'Success!',
                text: 'Sub-sections rearranged successfully',
                icon: 'success',
                confirmButtonText: 'OK',
              });
            }
          } else {
            this.swalWithBootstrapButtons.fire({
              title: 'Failure!',
              text: 'An error occured while rearranging the sub-sections.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        },
      });
    });
  }
  dropSubSectionContainer(event: CdkDragDrop<string[]>) {
    this.isSaved = false;
    moveItemInArray(
      this.activeSection.Sections,
      event.previousIndex,
      event.currentIndex
    );
    this.activeSection.Sections[event.currentIndex]['Sequence'] =
      Number(event.currentIndex) + 1;
    this.activeSection.Sections[event.previousIndex]['Sequence'] =
      Number(event.previousIndex) + 1;
    if (!this.isSaved) {
      this.saveAllSubSections();
    }
  }

  order(index: number, up: boolean) {
    if (up) {
      // move up
      if (index !== 0) {
        const temp = this.addformData[index - 1];
        this.addformData[index - 1] = this.addformData[index];
        this.addformData[index] = temp;
      }
    } else {
      if (index != this.addformData.length) {
        const temp = this.addformData[index + 1];
        this.addformData[index + 1] = this.addformData[index];
        this.addformData[index] = temp;
      }
    }
  }

  previewSubmitter = false;
  selectedQuestion(adddata: any) {
    this.previewSubmitter = false;
    if (adddata.displayquestion == 'Submitter') {
      this.previewSubmitter = true;
      this.selectedQuestionPreview = adddata;
    } else {
      this.previewSubmitter = false;
      this.selectedQuestionPreview = adddata;
    }
  }
  onSubmitFile(fm: NgForm, editIndex: any) {
    let filehtmlcontent = ``;
    filehtmlcontent =
      filehtmlcontent +
      `<div style='text-align:` +
      fm.value.align +
      `'><input onclick="event.preventDefault()" type="file" id="fileID_` +
      this.create_UUID() +
      `"/><div style="margin-top: 8px; font-size: 13px; color: #333;"><b>Note:</b> Upload files in PDF, Word, and Excel formats, up to 5 MB.</div></div><br>`;
    this.sanitizer.bypassSecurityTrustHtml(filehtmlcontent);
    if (editIndex >= 0) {
      this.formData.splice(editIndex, 1, {
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(filehtmlcontent),
        displaytext: this.fileToUpload?.name ?? 'noFileName',
        file: this.fileToUpload ?? 'noFile',
        index: this.formData.length + 1,
        type: 'file',
        fileData: this.fileUploadFormData,
      });
    } else {
      this.formData.push({
        divcontnt: this.sanitizer.bypassSecurityTrustHtml(filehtmlcontent),
        displaytext: this.fileToUpload?.name ?? 'noFileName',
        file: this.fileToUpload ?? 'noFile',
        index: this.formData.length + 1,
        type: 'file',
        fileData: this.fileUploadFormData,
      });
    }
    this.isFormFieldUnsupported = this.checkFormFieldEligibilty(this.formData);
    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
    console.log("On file submit successful");
  }
  handleFileInput(event: any, editIndex: any) {
    let supportedFormats = [
      '.pdf',
      'application/pdf',
      '.csv',
      'text/csv',
      '.xls',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
    ];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fsize = file.size;
      const fileInMB = Math.round(fsize / 1024);
      if (fileInMB >= 5 * 1024) {
        this.fileToUpload = 'noFileToUpload';
        alert('File is too large. Over 5MB');
      } else {
        if (supportedFormats.includes(file?.type)) {
          this.fileToUpload = event.target.files[0];
          this.fileUploadFormData.append(
            'fileData',
            this.fileToUpload,
            this.fileToUpload.name
          );
        } else {
          this.fileToUpload = 'noFileToUpload';
          alert('Invalid file format');
        }
      }
    }
  }
  clearFile() {
    this.fileUpload
      ? (this.fileUpload.nativeElement.value = 'noFileToUpload')
      : '';
  }

  onValueChangeEmit(event) {
    this.formData[event.quesIndex].value = event.data;
  }

  isDynamicFieldAppear(fieldType) {
    let isDisplay = false;
    if (fieldType == 'textbox') {
      isDisplay = true;
    } else if (fieldType == 'textarea') {
      isDisplay = true;
    } else if (fieldType == 'date') {
      isDisplay = true;
    }

    return isDisplay;
  }

  getTodayDate() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = this.zeroPad(dd);
    }
    if (mm < 10) {
      mm = this.zeroPad(mm);
    }

    let maxToday = yyyy + '-' + mm + '-' + dd;
    return maxToday;
  }

  zeroPad(num) {
    return num.toString().padStart(2, '0');
  }

  isContainsEmptyOption() {
    return this.dropdownRef.options.some((option: any) =>
      Utils.isEmpty(option.answer)
    );
  }
  doesContainEmptyOption() {
    return this.multiSelectDropdownRef.options.some((dropdown: any) =>
      Utils.isEmpty(dropdown.answer)
    );
  }
  doesContainEmptyRadioOption() {
    return this.radioRef.options.some((radioOption: any) =>
      Utils.isEmpty(radioOption.answer)
    );
  }
  doesContainEmptyCheckboxOption() {
    return this.checkboxRef.options.some((checkboxOption: any) =>
      Utils.isEmpty(checkboxOption.answer)
    );
  }
  isRenderQuestion(tagData: any) {
    let isRender = true;
    if (tagData?.isShortText) {
      isRender = false;
    } else if (tagData?.alignment == 'vertical') {
      isRender = false;
    }
    return isRender;
  }

  isContainsVerticalAlignment() {
    return this.formData.some((data: any) => data?.alignment == 'vertical');
  }

  isContainsVerticalAlignmentPreview(adddata: any) {
    return adddata?.data.some((data: any) => data?.alignment == 'vertical');
  }

  addSection(sectionContent) {
    if (
      !window.location.origin.includes('localhost') &&
      !this.isSaved &&
      this.currentSectionID &&
      this.isSection
    ) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save current section',
        icon: 'warning',
      });
      return;
    }
    this.sectionEditIndex = null;
    this.sectionDescription.setValue('');
    this.sectionTitle.setValue('');
    this.sectionDisplayType.setValue('One');
    this.modalService.open(sectionContent, {
      size: 'sl',
      scrollable: false,
      windowClass: 'modalHeight',
    });
  }
  sections = new Sections();
  currentSectionID: any;
  currentSectionTitle = '';
  onSubmitSection(fm: any, sectionEditIndex: any = null) {
    this.isSaved = false;
    let sectionInfo = new SectionInfo();
    this.currentSectionTitle = this.sectionTitle.value;
    if (sectionEditIndex === null) {
      // Fix: display the questions added into the section
      const newSectionId = (this.currentSectionID = uuid());
      localStorage.setItem('SectionId', newSectionId);

      sectionInfo.UniqueID = this.currentSectionID;
      sectionInfo.Title = this.sectionTitle.value;
      sectionInfo.Description = this.sectionDescription.value;
      sectionInfo.DisplayType = this.sectionDisplayType.value ?? 'One';
      sectionInfo.TemplateID = localStorage.getItem('TemplateId') || '';
      sectionInfo.CreatedBy.UniqueID = localStorage.getItem('UserId');
      sectionInfo.UpdatedBy.UniqueID = localStorage.getItem('UserId');
      sectionInfo.Sequence = Number(this.sections?.Section?.length ?? 0) + 1;

      this.sections.Section.push(sectionInfo);
    } else {
      this.sections.Section[sectionEditIndex].Title = this.sectionTitle.value;
      this.sections.Section[sectionEditIndex].Description =
        this.sectionDescription.value;
      this.sections.Section[sectionEditIndex].DisplayType =
        this.sectionDisplayType.value ?? 'One';
    }
    this.isSectionsListCollapsed = false;
    this.activeSection =
      sectionEditIndex !== null
        ? this.sections?.Section?.[sectionEditIndex]
        : this.sections?.Section?.at(-1);
    this.activeSectionIndex = this.sections?.Section?.findIndex(
      (s) => s.UniqueID === this.activeSection?.UniqueID
    );
    this.isDragablelistDisable = false;
    if (!this.activeSection.UpdatedBy) {
      this.activeSection.UpdatedBy = {
        UniqueID: localStorage.getItem('UserId'),
      };
    }
    this.apiService.SaveSection(this.activeSection).subscribe({
      next: (resp) => {
        this.isSaved = true;
        localStorage.removeItem('SubSectionId');
        this.activeSubSection = null;
        this.activeSubSectionIndex = null;
        this.swalWithBootstrapButtons.fire({
          title: 'Success!',
          text: 'Section saved successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      },
      error: (err) => {
        if (window.location.origin.includes('localhost')) {
          this.isSaved = true; // To bypass Save warning in localhost
          localStorage.removeItem('SubSectionId');
          this.activeSubSection = null;
          this.activeSubSectionIndex = null;
        }
      },
    });

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
  }

  subSectionTitle = new FormControl('');
  subSectionDescription = new FormControl('');
  addSubSection(subSectionContent) {
    if (!this.isSaved && this.currentSubSectionID && this.isSection) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save current section',
        icon: 'warning',
      });
      return;
    }
    this.subSectionEditIndex = null;
    this.subSectionDescription.setValue('');
    this.subSectionTitle.setValue('');
    this.modalService.open(subSectionContent, {
      size: 'sl',
      scrollable: false,
      windowClass: 'modalHeight',
    });
  }
  currentSubSectionID;
  currentSubSectionTitle;
  onSubmitSubSection(fm: any, idxOfSubSectionToBeUpdated: any = null) {
    this.isSaved = false;
    let subSectionInfo = new SectionInfo();
    this.currentSubSectionTitle = this.subSectionTitle.value;
    if (idxOfSubSectionToBeUpdated === null) {
      const newSubSectionId = (this.currentSubSectionID = uuid());
      localStorage.setItem('SubSectionId', newSubSectionId);

      subSectionInfo.UniqueID = this.currentSubSectionID;
      subSectionInfo.Title = this.subSectionTitle.value;
      subSectionInfo.Description = this.subSectionDescription.value;
      subSectionInfo.TemplateID = localStorage.getItem('TemplateId') || '';
      subSectionInfo.ParentID = this.activeSection.UniqueID;
      subSectionInfo.CreatedBy.UniqueID = localStorage.getItem('UserId');
      subSectionInfo.UpdatedBy.UniqueID = localStorage.getItem('UserId');
      subSectionInfo.Sequence =
        Number(this.activeSection?.Sections?.length ?? 0) + 1;

      if (!this.activeSection.Sections) this.activeSection.Sections = [];
      this.activeSection.Sections.push(subSectionInfo);
    } else {
      this.activeSection.Sections[idxOfSubSectionToBeUpdated].Title =
        this.subSectionTitle.value;
      this.activeSection.Sections[idxOfSubSectionToBeUpdated].Description =
        this.subSectionDescription.value;
    }

    this.isDragablelistDisable = false;
    this.isSubSectionsListCollapsed = false;
    this.activeSubSection = idxOfSubSectionToBeUpdated
      ? this.activeSection?.Sections?.[idxOfSubSectionToBeUpdated]
      : this.activeSection?.Sections?.at(-1);
    this.activeSubSectionIndex = this.activeSection?.Sections?.findIndex(
      (s) => s.UniqueID === this.activeSubSection.UniqueID
    );

    if (!this.activeSubSection.UpdatedBy) {
      this.activeSubSection.UpdatedBy = {
        UniqueID: localStorage.getItem('UserId'),
      };
    }
    this.apiService.SaveSection(this.activeSubSection).subscribe({
      next: (resp) => {
        this.isSaved = true;

        this.expandSubSectionsFor(this.activeSection, this.activeSectionIndex);
        this.swalWithBootstrapButtons.fire({
          title: 'Success!',
          text: 'Sub-section saved successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      },
      error: (err) => {
        if (window.location.origin.includes('localhost')) {
          this.isSaved = true; // To bypass Save warning in localhost

          this.expandSubSectionsFor(
            this.activeSection,
            this.activeSectionIndex
          );
        }
      },
    });

    // On Submit Element
    this.modalService.dismissAll();
    this.resetAllModalRefs();
  }

  activeSectionIndex;
  activeSubSectionIndex;
  activeSection: ISectionInfo;
  activeSubSection: ISectionInfo;
  setSectionDetails(section: any, index?: number) {
    if (!this.isSaved && this.currentSectionID && this.isSection) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save current section',
        icon: 'warning',
      });
      return;
    }
    this.currentSectionID = section.UniqueID;

    localStorage.setItem('SectionId', section.UniqueID);

    this.currentSectionTitle = section.Title;
    this.activeSection =
      section ??
      this.sections.Section.find((s) => s.UniqueID === this.currentSectionID);
    this.activeSubSection = null;
    localStorage.removeItem('SubSectionId');
    this.activeSectionIndex = index;

    // Disable drag-drop if section has subsections => section can either have only subsections or only fields
    const doesSectionContainSubSections = Boolean(
      this.activeSection?.Sections?.length
    );
    this.isDragablelistDisable = doesSectionContainSubSections;
  }
  setSubSectionDetails(subSection: any, index?: number) {
    if (
      !window.location.origin.includes('localhost') &&
      !this.isSaved &&
      this.currentSubSectionID &&
      this.isSection
    ) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save current section',
        icon: 'warning',
      });
      return;
    }
    this.currentSubSectionID = subSection.UniqueID;
    localStorage.setItem('SubSectionId', subSection.UniqueID);
    this.currentSubSectionTitle = subSection.Title;
    this.activeSubSection =
      subSection ??
      this.activeSection.Sections.find(
        (ss) => ss.UniqueID === this.currentSubSectionID
      );
    this.activeSubSectionIndex = index;
    this.isDragablelistDisable = false;
  }
  sectionEditIndex: any = null;
  subSectionEditIndex: any = null;
  editSection(index: number) {
    this.sectionEditIndex = index;
    this.sectionDescription.setValue(
      this.sections.Section[this.sectionEditIndex]?.Description
    );
    this.sectionTitle.setValue(
      this.sections.Section[this.sectionEditIndex]?.Title
    );
    this.sectionDisplayType.setValue(
      this.sections.Section[this.sectionEditIndex]?.DisplayType ?? 'One'
    );
    this.modalService.open(this.sectionContentRef, {
      size: 'sl',
      scrollable: false,
      windowClass: 'modalHeight',
    });
  }
  editSubSection(index: number) {
    this.subSectionEditIndex = index;

    this.subSectionDescription.setValue(
      this.activeSection?.Sections[index]?.Description
    );
    this.subSectionTitle.setValue(this.activeSection?.Sections[index]?.Title);
    this.modalService.open(this.subSectionContentRef, {
      size: 'sl',
      scrollable: false,
      windowClass: 'modalHeight',
    });
  }
  sectionDeleteIndex: any = null;
  subSectionDeleteIndex: any = null;

  doesConditionalLogicExistForSection(secItem: ISectionInfo): boolean {
    let desiredResult: boolean;
    if (secItem?.Sections?.length) {
      desiredResult = secItem.Sections.some((subSecItem) =>
        this.doesConditionalLogicExistForSection(subSecItem)
      );
    } else {
      if (secItem?.Fields?.length) {
        desiredResult = secItem.Fields.some((field) =>
          this.doesConditionalLogicExistForField(field)
        );
      }
    }
    return desiredResult;
  }

  doesConditionalLogicExistForField(fieldItem: IField): boolean {
    let desiredResult =
      this.isIdPresentInLinks(fieldItem.UniqueID) ||
      this.isIdPresent(fieldItem.UniqueID);

    return desiredResult;
  }

  deleteSection(sectionID: any) {
    if (this.doesConditionalLogicExistForSection(this.activeSection)) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Conditional logic exists for the section. If you want to delete the section please delete the logic mapped to the section fields in the logic builder section.',
        icon: 'warning',
      });
    } else {
      if (confirm('Are you sure want to delete the section?')) {
        this.apiService
          .DeleteSection({
            UniqueID: sectionID,
            UpdatedBy: {
              Name: '',
              Email: '',
              UPN: '',
              UniqueID: localStorage.getItem('UserId'),
            },
          })
          .subscribe({
            next: (resp) => {
              this.removeSectionFromView(sectionID);
            },
            error: (err) => {
              // Bypass API to Test delete in localhost
              if (window.location.origin.includes('localhost')) {
                this.removeSectionFromView(sectionID);
              }
            },
          });
      }
    }
  }
  deleteSubSection(subSectionID: any) {
    if (this.doesConditionalLogicExistForSection(this.activeSubSection)) {
      this.swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Conditional logic exists for the section. If you want to delete the section please delete the logic mapped to the section fields in the logic builder section.',
        icon: 'warning',
      });
    } else {
      if (confirm('Are you sure want to delete the Sub-section?')) {
        this.apiService
          .DeleteSection({
            UniqueID: subSectionID,
            UpdatedBy: {
              Name: '',
              Email: '',
              UPN: '',
              UniqueID: localStorage.getItem('UserId'),
            },
          })
          .subscribe({
            next: (resp) => {
              this.removeSubSectionFromView(subSectionID);
            },
            error: (err) => {
              // Bypass API to Test delete in localhost
              if (window.location.origin.includes('localhost')) {
                this.removeSubSectionFromView(subSectionID);
              }
            },
          });
      }
    }
  }

  removeSectionFromView(sectionID) {
    const idxOfSecToBeDeleted = this.sections?.Section?.findIndex(
      (s) => s.UniqueID === sectionID
    );

    // Remove the section's sub sections and fields from view
    if (this.sections?.Section?.[idxOfSecToBeDeleted]?.Sections) {
      this.sections.Section[idxOfSecToBeDeleted].Sections?.forEach((subSec) =>
        this.removeSubSectionFromView(subSec?.UniqueID)
      );
    }

    // Remove the section from view
    this.sections?.Section?.splice(idxOfSecToBeDeleted, 1);
    // Set active section
    if (this.sections?.Section?.at(idxOfSecToBeDeleted - 1)) {
      this.activeSection = this.sections?.Section?.at(idxOfSecToBeDeleted - 1);
    }

    // update localstorage
    localStorage.setItem(
      'SectionId',
      this.activeSection?.UniqueID ??
      this.sections?.Section?.[0]?.UniqueID ??
      ''
    );
    localStorage.setItem(
      'AllQuestions',
      JSON.stringify([{ Section: this.sections }])
    );
  }
  removeSubSectionFromView(subSectionID) {
    this.addformData = this.addformData?.filter(
      (field) => field.sectionId !== subSectionID
    );

    // Query to select respective section & subsection indices
    let secIdxOfSubSecToBeDeleted = null;
    let idxOfSubSecToBeDeleted = null;
    this.sections?.Section?.forEach((sec, secIdx) => {
      if (sec?.Sections?.length) {
        sec?.Sections?.forEach((subSec, subSecIdx) => {
          if (subSec?.UniqueID === subSectionID) {
            secIdxOfSubSecToBeDeleted = secIdx;
            idxOfSubSecToBeDeleted = subSecIdx;
          }
        });
      }
    });

    // Remove the sub section from view
    this?.sections?.Section?.[secIdxOfSubSecToBeDeleted]?.Sections?.splice(
      idxOfSubSecToBeDeleted,
      1
    );

    if (
      this.sections?.Section?.[secIdxOfSubSecToBeDeleted]?.Sections?.at(
        idxOfSubSecToBeDeleted - 1
      )
    ) {
      this.activeSubSection =
        this.sections?.Section?.[secIdxOfSubSecToBeDeleted]?.Sections?.[
        idxOfSubSecToBeDeleted - 1
        ];
    } else {
      if (this.sections?.Section?.at(secIdxOfSubSecToBeDeleted - 1)) {
        this.activeSection =
          this.sections?.Section?.[secIdxOfSubSecToBeDeleted - 1];
        this.activeSubSection =
          this.sections?.Section?.[secIdxOfSubSecToBeDeleted - 1]?.Sections?.at(
            -1
          );
      } else {
        this.activeSection = this.sections?.Section?.at(-1);
        this.activeSubSection =
          this.sections?.Section?.at(-1)?.Sections?.at(-1);
      }
    }

    // update local storage
    localStorage.setItem(
      'SectionId',
      this.activeSection?.UniqueID ??
      this.sections?.Section?.[0]?.UniqueID ??
      ''
    );
    localStorage.setItem(
      'SubSectionId',
      this.activeSubSection?.UniqueID ??
      this.sections?.Section?.[0]?.Sections?.[0]?.UniqueID ??
      ''
    );
    localStorage.setItem(
      'AllQuestions',
      JSON.stringify([{ Section: this.sections }])
    );
  }

  ctrlFormContainerAccordian(index: number) {
    this.addformData = [];
    let Question: any = [];
    Question = this.reverseObjectMapper(this.sections.Section);
    this.addformData = Question;
    this.sectionCtrl[index].isOpen = this.sectionCtrl[index].isOpen
      ? false
      : true;
  }

  isSectionWithOutQuestion() {
    let isDisabled = false;
    for (let sectionInfo of this.sections.Section) {
      let isFound = this.addformData.some(
        (formData) => formData.sectionId === sectionInfo.UniqueID
      );

      if (!isFound) {
        isDisabled = true;
        break;
      }
    }
    return isDisabled;
  }
  previewSectionUniqueID;
  onSectionSelection(section, index) {
    this.previewSectionUniqueID = section.UniqueID;
    if (this.selectedSectionIndex == index) {
      this.selectedSectionIndex = null;
    } else {
      this.selectedSectionIndex = index;
    }

    this.selectedQuestionPreview = null;
  }

  addSubmitterSection(type: any) {
    if (type == 'Submitter') {
      this.isSaved = false;
      let sectionInfo = new SectionInfo();
      if (this.currentSectionID == localStorage.getItem('SectionId')) {
        if (this.submitterSectionID == '') {
          this.currentSectionID = uuid();
          this.submitterSectionID = this.currentSectionID;
          sectionInfo.UniqueID = this.currentSectionID;
          sectionInfo.Title = 'Submitter';
          if (this.addformData.length) {
            sectionInfo.Sequence = 2;
            this.sections.Section.filter(
              (item) => item.Title !== 'Submitter'
            )[0].Sequence = 1;
          } else {
            sectionInfo.Sequence = 1;
            this.sections.Section.filter(
              (item) => item.Title !== 'Submitter'
            )[0].Sequence = 2;
          }
          let sectionCtrl = {
            index:
              this.sections.Section.length > 0
                ? this.sections.Section.length + 1
                : 0,
            uniqueId: sectionInfo.UniqueID,
            isOpen: true,
          };
          sectionInfo.Description = 'Submitter';
          sectionInfo.TemplateID = localStorage.getItem('TemplateId') || '';

          sectionInfo.CreatedBy.UniqueID = localStorage.getItem('UserId');
          sectionInfo.UpdatedBy.UniqueID = localStorage.getItem('UserId');
          this.sections.Section.push(sectionInfo);
          this.sectionCtrl.push(sectionCtrl);
        }
      }
    }
  }
  isexpanded = false;
  submitterSectionID = '';
  toggleExpand() {
    const swalWithBootstrapButtons = swal.mixin({
      customClass: {
        confirmButton: 'btn',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });
    if (!this.isOtherQuestiosSaved) {
      swalWithBootstrapButtons.fire({
        title: 'Warning!',
        text: 'Please Save Questions Before adding submitter control',
        icon: 'warning',
      });
      this.currentSectionID = localStorage.getItem('SectionId');
      return;
    }
    this.isDragablelistDisable = false;
    this.addSubmitterSection('Submitter');
  }

  isSubmitterControlexpanded = true;
  toggleExpandCopltedForm() {
    this.isSubmitterControlexpanded = !this.isSubmitterControlexpanded;
  }
  onFileImport(evt: Event) {
    this.uploadedFile = Array.from((evt.target as HTMLInputElement).files ?? []);
  }
  async onImportClick() {
    for (const f of this.uploadedFile) {
      const text = await f.text();
      const data = JSON.parse(text.replace(/^\uFEFF/, ''));

      const secDetails = data.Questionnaire[0].Section.map((item) => {
        item.UniqueID = this.create_UUID();
        item.TemplateID = localStorage.getItem('TemplateId');
        item.Fields = (item.Fields ?? []).map((field) => {
          field.UniqueID = this.create_UUID();
          return field;
        });
        return item;
      });

      const secDetailsModified = this.manipulateTemplateIds(secDetails);

      secDetailsModified.forEach((sec) => {
        this.saveCurr(sec);
      });

      const conditionalDetails = {
        ...data.ConditionalLogic,
        TemplateID: localStorage.getItem('TemplateId'),
      };
      this.saveConditionalDetails(conditionalDetails);
    }
    this.modalQuestionImportResponse.close();
    this.reloadPage();

  }
  deleteUploadedFile() {
    this.uploadedFile = null;
  }

  reloadPage() {
    window.location.reload();
  }
}
